const ArrowRight = ({ wh, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.1667 6.66667L17.5 10M17.5 10L14.1667 13.3333M17.5 10L2.5 10"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowLeft = ({ color, w, h }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15L1 8M1 8L8 1M1 8L19 8"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Interrogation = ({ wh, color, strokeW }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke={color}
      strokeWidth={strokeW}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.103 13.821C11.103 14.1011 11.33 14.3281 11.6101 14.3281H12.2514C12.5315 14.3281 12.7585 14.1011 12.7585 13.821C12.7685 12.7671 13.1115 12.6626 13.9219 12.1655C14.8366 11.6186 15.4084 10.8729 15.4084 9.73438C15.4084 8.05398 14.1009 7 12.2017 7C10.7651 7 9.5521 7.65745 9.14478 8.94997C8.99363 9.42962 9.41484 9.85369 9.91774 9.85369C10.3948 9.85369 10.7517 9.44423 11.0219 9.05104C11.2899 8.66109 11.7356 8.47159 12.1918 8.47159C12.9524 8.47159 13.5639 8.97869 13.5639 9.75923C13.5639 10.4553 13.1016 10.9325 12.5 11.3104C11.62 11.8572 11.1129 12.0313 11.103 13.821ZM11.973 17.4304C12.5597 17.4304 13.0618 16.9432 13.0668 16.3366C13.0618 15.7401 12.5597 15.2528 11.973 15.2528C11.3665 15.2528 10.8743 15.7401 10.8793 16.3366C10.8743 16.9432 11.3665 17.4304 11.973 17.4304Z"
      fill={color}
    />
  </svg>
);

const ProfileDefault = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Bars = ({ wh = 24 }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H20M4 12H20M4 18H20"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Close = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    className={color}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 18L18 6M6 6L18 18"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CloseModal = ({ wh = 14 }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13L13 1M1 1L13 13"
      stroke="#374151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Facebook = ({ wh = 20 }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 14.991 3.657 19.128 8.438 19.878V12.891H5.898V10H8.438V7.797C8.438 5.291 9.93 3.907 12.215 3.907C13.309 3.907 14.453 4.102 14.453 4.102V6.562H13.193C11.95 6.562 11.563 7.333 11.563 8.124V10H14.336L13.893 12.89H11.563V19.878C16.343 19.128 20 14.991 20 10Z"
      fill="#9CA3AF"
    />
  </svg>
);

const Instagram = ({ wh = 20 }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.315 0C12.745 0 13.099 0.0129999 14.123 0.0599999C15.187 0.109 15.914 0.278 16.55 0.525C17.2175 0.775874 17.8222 1.16936 18.322 1.678C18.8306 2.17777 19.2241 2.7825 19.475 3.45C19.722 4.086 19.891 4.813 19.94 5.877C19.988 6.944 20 7.284 20 10V10.08C20 12.723 19.988 13.067 19.94 14.123C19.891 15.187 19.722 15.914 19.475 16.55C19.2241 17.2175 18.8306 17.8222 18.322 18.322C17.8222 18.8306 17.2175 19.2241 16.55 19.475C15.914 19.722 15.187 19.891 14.123 19.94C13.056 19.988 12.716 20 10 20H9.92C7.277 20 6.933 19.988 5.877 19.94C4.813 19.891 4.086 19.722 3.45 19.475C2.7825 19.2241 2.17777 18.8306 1.678 18.322C1.16936 17.8222 0.775874 17.2175 0.525 16.55C0.278 15.914 0.109 15.187 0.0599999 14.123C0.0129999 13.099 0 12.744 0 10.315V9.685C0 7.255 0.0129999 6.901 0.0599999 5.877C0.109 4.813 0.278 4.086 0.525 3.45C0.775874 2.7825 1.16936 2.17777 1.678 1.678C2.17777 1.16936 2.7825 0.775874 3.45 0.525C4.086 0.278 4.813 0.109 5.877 0.0599999C6.901 0.0129999 7.256 0 9.685 0H10.315ZM10.234 1.802H9.766C7.31 1.802 6.982 1.813 5.959 1.86C4.984 1.905 4.455 2.067 4.102 2.204C3.635 2.386 3.302 2.602 2.952 2.952C2.602 3.302 2.386 3.635 2.204 4.102C2.067 4.455 1.904 4.984 1.86 5.959C1.813 6.982 1.802 7.31 1.802 9.766V10.234C1.802 12.69 1.813 13.018 1.86 14.041C1.905 15.016 2.067 15.545 2.204 15.898C2.386 16.364 2.603 16.698 2.952 17.048C3.302 17.398 3.635 17.614 4.102 17.796C4.455 17.933 4.984 18.096 5.959 18.14C7.013 18.188 7.329 18.198 10 18.198H10.08C12.677 18.198 12.997 18.188 14.04 18.14C15.016 18.095 15.545 17.933 15.898 17.796C16.364 17.614 16.698 17.398 17.048 17.048C17.398 16.698 17.614 16.365 17.796 15.898C17.933 15.545 18.096 15.016 18.14 14.041C18.188 12.986 18.198 12.671 18.198 10V9.92C18.198 7.323 18.188 7.003 18.14 5.96C18.095 4.984 17.933 4.455 17.796 4.102C17.6358 3.66757 17.3802 3.2746 17.048 2.952C16.7254 2.61986 16.3324 2.36426 15.898 2.204C15.545 2.067 15.016 1.904 14.041 1.86C13.018 1.813 12.69 1.802 10.234 1.802ZM10 4.865C10.6743 4.865 11.3421 4.99782 11.9651 5.25588C12.5881 5.51394 13.1542 5.89218 13.631 6.36901C14.1078 6.84584 14.4861 7.41191 14.7441 8.03492C15.0022 8.65793 15.135 9.32566 15.135 10C15.135 10.6743 15.0022 11.3421 14.7441 11.9651C14.4861 12.5881 14.1078 13.1542 13.631 13.631C13.1542 14.1078 12.5881 14.4861 11.9651 14.7441C11.3421 15.0022 10.6743 15.135 10 15.135C8.63811 15.135 7.33201 14.594 6.36901 13.631C5.40601 12.668 4.865 11.3619 4.865 10C4.865 8.63811 5.40601 7.33201 6.36901 6.36901C7.33201 5.40601 8.63811 4.865 10 4.865ZM10 6.667C9.11603 6.667 8.26827 7.01815 7.64321 7.64321C7.01815 8.26827 6.667 9.11603 6.667 10C6.667 10.884 7.01815 11.7317 7.64321 12.3568C8.26827 12.9818 9.11603 13.333 10 13.333C10.884 13.333 11.7317 12.9818 12.3568 12.3568C12.9818 11.7317 13.333 10.884 13.333 10C13.333 9.11603 12.9818 8.26827 12.3568 7.64321C11.7317 7.01815 10.884 6.667 10 6.667ZM15.338 3.462C15.6563 3.462 15.9615 3.58843 16.1865 3.81347C16.4116 4.03852 16.538 4.34374 16.538 4.662C16.538 4.98026 16.4116 5.28548 16.1865 5.51053C15.9615 5.73557 15.6563 5.862 15.338 5.862C15.0197 5.862 14.7145 5.73557 14.4895 5.51053C14.2644 5.28548 14.138 4.98026 14.138 4.662C14.138 4.34374 14.2644 4.03852 14.4895 3.81347C14.7145 3.58843 15.0197 3.462 15.338 3.462Z"
      fill="#9CA3AF"
    />
  </svg>
);

const Linkedin = ({ wh = 20 }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 18.9119V1.09392C0.0218752 1.07332 0.0540445 1.05659 0.0643387 1.02957C0.342925 0.29407 0.888519 0 1.65801 0C7.24518 0.0064348 12.8319 0.0077216 18.4182 0.00386072C19.3923 0.00386072 19.9997 0.61002 19.9997 1.58103C19.9997 7.18832 19.9997 12.7956 19.9997 18.4029C20.0022 18.552 19.9895 18.701 19.9617 18.8475C19.833 19.464 19.3994 19.7902 18.848 20H1.09054C0.597843 19.7952 0.205912 19.4042 0 18.9119ZM10.6365 8.74489C10.6365 8.41414 10.6262 8.08404 10.6403 7.75393C10.6487 7.56089 10.6017 7.49654 10.3958 7.49654C9.61606 7.50877 8.83628 7.5062 8.05649 7.49654C7.87184 7.49654 7.79914 7.52679 7.79914 7.7372C7.806 10.7487 7.806 13.7604 7.79914 16.7723C7.79914 16.9814 7.8564 17.0471 8.06872 17.0439C8.83757 17.0323 9.60706 17.0245 10.3759 17.0439C10.6764 17.0529 10.7722 16.9853 10.769 16.6655C10.7529 15.0742 10.7619 13.4828 10.769 11.8915C10.7633 11.4735 10.854 11.0597 11.0341 10.6824C11.3391 10.0653 11.9786 9.77704 12.8021 9.87549C13.4185 9.94884 13.8206 10.3388 13.9744 11.017C14.0569 11.4252 14.0938 11.8413 14.0844 12.2577C14.0844 13.7422 14.0921 15.2273 14.0792 16.7112C14.0792 16.9827 14.159 17.049 14.4209 17.0432C15.1891 17.0261 15.9579 17.0261 16.7274 17.0432C16.9796 17.0484 17.0491 16.9789 17.0491 16.7215C17.0375 15.0343 17.0491 13.3471 17.0401 11.6592C17.0474 11.029 16.9864 10.3999 16.858 9.78283C16.6534 8.87359 16.2623 8.07439 15.3782 7.65419C14.4569 7.20467 13.3997 7.12009 12.4187 7.41739C11.6678 7.64261 11.1152 8.12844 10.6365 8.74489ZM2.96794 12.2474C2.96794 13.7512 2.9718 15.2556 2.9628 16.7601C2.9628 16.9827 3.02714 17.0516 3.24975 17.0477C4.05012 17.0348 4.8505 17.0348 5.65087 17.0477C5.8812 17.0522 5.93396 16.9756 5.93331 16.7575C5.92774 13.7597 5.92774 10.762 5.93331 7.76423C5.93331 7.5551 5.87477 7.49461 5.66438 7.49847C4.864 7.5107 4.06363 7.51327 3.2639 7.49847C3.02263 7.49333 2.96022 7.56282 2.96215 7.79962C2.97309 9.28091 2.96794 10.7641 2.96794 12.2474ZM2.74598 4.47991C2.74725 4.81794 2.84877 5.14799 3.03767 5.4283C3.22657 5.70861 3.49436 5.92657 3.80717 6.0546C4.11997 6.18263 4.46372 6.21498 4.79491 6.14755C5.1261 6.08012 5.42985 5.91594 5.66771 5.67579C5.90557 5.43564 6.06686 5.13032 6.13116 4.79846C6.19545 4.4666 6.15987 4.12312 6.02891 3.81149C5.89796 3.49986 5.67751 3.23409 5.39548 3.04782C5.11344 2.86154 4.7825 2.76313 4.44452 2.76503C3.99246 2.76894 3.56026 2.95138 3.24211 3.27259C2.92395 3.59381 2.74562 4.02777 2.74598 4.47991Z"
      fill="#9CA3AF"
    />
  </svg>
);

const Mail = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronRight = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5L16 12L9 19"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HomeSvg = ({ wh = 16 }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711C0.683417 9.09763 1.31658 9.09763 1.70711 8.70711L2 8.41421V15C2 15.5523 2.44772 16 3 16H5C5.55228 16 6 15.5523 6 15V13C6 12.4477 6.44772 12 7 12H9C9.55229 12 10 12.4477 10 13V15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15V8.41421L14.2929 8.70711C14.6834 9.09763 15.3166 9.09763 15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L8.70711 0.292893Z"
      fill="#111827"
    />
  </svg>
);

// lucide « plus », as on the prototype.
const Plus = ({ wh, color, className }) => (
  <svg
    className={className}
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12h14M12 5v14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronDown = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9L12 16L5 9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Localisation = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.714 12.8807C11.9864 13.6083 10.5188 15.0758 9.41335 16.1813C8.6323 16.9624 7.36751 16.9623 6.58646 16.1813C5.50084 15.0957 4.06038 13.6552 3.28587 12.8807C0.682378 10.2772 0.682378 6.05612 3.28587 3.45262C5.88937 0.849126 10.1105 0.849126 12.714 3.45262C15.3175 6.05612 15.3175 10.2772 12.714 12.8807Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4999 8.16667C10.4999 9.54738 9.38063 10.6667 7.99992 10.6667C6.61921 10.6667 5.49992 9.54738 5.49992 8.16667C5.49992 6.78596 6.61921 5.66667 7.99992 5.66667C9.38063 5.66667 10.4999 6.78596 10.4999 8.16667Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronLeft = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 19L8 12L15 5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const JobbizLogo = ({ wh }) => (
  <svg
    width={wh}
    viewBox="0 0 56 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83502 0H8.00343V7.8063C8.00343 8.31884 7.88514 8.8313 7.68801 9.3044C7.49088 9.77751 7.1755 10.1718 6.78125 10.5266C5.99273 11.2363 5.00706 11.6306 3.94257 11.6306C3.43003 11.6306 2.87807 11.5123 2.40496 11.3152C1.93185 11.118 1.49819 10.842 1.14335 10.5266C0.788523 10.1718 0.512553 9.77751 0.315425 9.3044C0.118296 8.8313 0 8.31884 0 7.8063H2.05016C2.05016 8.04286 2.08955 8.27934 2.20783 8.51589C2.32611 8.71302 2.44438 8.9102 2.60209 9.06791C2.79921 9.22561 2.99638 9.38331 3.23294 9.46216C3.70604 9.65929 4.25797 9.65929 4.73108 9.46216C5.16476 9.26504 5.5196 8.9102 5.71672 8.47652C5.835 8.23997 5.87444 8.0034 5.87444 7.76684L5.83502 0Z"
      fill="#FF9600"
    />
    <path
      d="M9.94938 7.52051C9.94938 6.96855 10.0677 6.41655 10.3042 5.90401C10.5408 5.43091 10.8168 4.95778 11.211 4.60295C11.6053 4.20869 12.0784 3.93273 12.5515 3.7356C13.616 3.30192 14.7987 3.30192 15.8632 3.7356C16.3758 3.93273 16.8095 4.24812 17.2037 4.60295C17.598 4.95778 17.9134 5.43091 18.1105 5.90401C18.5442 6.92908 18.5442 8.07247 18.1105 9.09753C17.874 9.57064 17.598 10.0438 17.2037 10.3986C16.8095 10.7929 16.3363 11.0688 15.8632 11.3053C14.7987 11.739 13.616 11.739 12.5515 11.3053C12.039 11.1082 11.5659 10.7929 11.211 10.3986C10.8168 10.0043 10.5408 9.57064 10.3042 9.09753C10.0677 8.62442 9.94938 8.07246 9.94938 7.52051ZM11.8812 7.52051C11.8812 7.83591 11.9601 8.11187 12.0784 8.38785C12.1966 8.66383 12.3544 8.9004 12.5515 9.09753C12.7486 9.29466 13.0246 9.49177 13.3006 9.57062C13.5765 9.6889 13.892 9.72829 14.2074 9.72829C14.5228 9.72829 14.7988 9.6889 15.1142 9.57062C15.3902 9.45234 15.6267 9.29466 15.8632 9.09753C16.5335 8.46672 16.7306 7.4811 16.3364 6.65316C16.2181 6.37718 16.0604 6.14061 15.8632 5.94348C15.6661 5.74635 15.3902 5.58867 15.1142 5.47039C14.8382 5.35211 14.5228 5.31263 14.2074 5.31263C13.892 5.31263 13.5765 5.39154 13.3006 5.47039C13.0246 5.58867 12.7881 5.74635 12.5515 5.94348C12.3544 6.14061 12.1572 6.37718 12.0784 6.65316C11.9601 6.92914 11.8812 7.2051 11.8812 7.52051Z"
      fill="#FF9600"
    />
    <path
      d="M27.5966 4.65225C27.2024 4.29742 26.7687 3.98203 26.2562 3.7849C25.7436 3.58778 25.1522 3.46948 24.6003 3.46948C23.8117 3.46948 23.0232 3.70601 22.353 4.1397V0H20.3817V7.53034C20.3817 8.0823 20.5 8.59484 20.7366 9.10737C20.9337 9.58048 21.2491 10.0142 21.6433 10.4084C22.0376 10.7633 22.4713 11.0787 22.9838 11.3152C23.4963 11.5124 24.0878 11.6306 24.6397 11.6306C25.2311 11.6306 25.783 11.5124 26.335 11.3152C26.8475 11.1181 27.2812 10.8027 27.6755 10.4084C28.0697 10.0536 28.3457 9.61991 28.5823 9.10737C28.7794 8.59484 28.8977 8.0823 28.8977 7.53034C28.8977 6.97838 28.7794 6.46585 28.5428 5.95332C28.3063 5.44078 27.9909 5.00708 27.5966 4.65225ZM26.6898 8.35832C26.5716 8.6343 26.4139 8.87078 26.2167 9.06791C26.0196 9.26504 25.7436 9.42282 25.4676 9.54109C25.1917 9.65937 24.8762 9.69876 24.5608 9.69876C24.2454 9.69876 23.9695 9.65937 23.6935 9.54109C23.4175 9.42282 23.1809 9.26504 22.9838 9.06791C22.7867 8.87078 22.629 8.6343 22.5107 8.35832C22.3924 8.08234 22.353 7.80629 22.353 7.49088C22.353 7.2149 22.4319 6.89955 22.5107 6.663C22.629 6.38702 22.7867 6.15044 22.9838 5.95332C23.1809 5.75619 23.4175 5.5985 23.6935 5.48023C23.9695 5.36195 24.2454 5.32247 24.5608 5.32247C24.8762 5.32247 25.1522 5.40138 25.4676 5.48023C25.7436 5.5985 25.9802 5.75619 26.2167 5.95332C26.4139 6.15044 26.5716 6.38702 26.6898 6.663C26.8081 6.93898 26.887 7.2149 26.887 7.49088C26.887 7.80629 26.8081 8.08234 26.6898 8.35832Z"
      fill="#FF9600"
    />
    <path
      d="M38.9653 5.95322C38.7682 5.48011 38.4528 5.04651 38.0585 4.65225C37.6643 4.29742 37.2306 3.98194 36.718 3.78481C36.2055 3.58768 35.6141 3.46948 35.0621 3.46948C34.2736 3.46948 33.4851 3.70601 32.8149 4.1397V0H30.8436V7.53025C30.8436 8.08221 30.9619 8.59474 31.1984 9.10728C31.3956 9.58038 31.711 10.0141 32.1052 10.4083C32.4995 10.7632 32.9332 11.0786 33.4457 11.3152C33.9582 11.5123 34.5496 11.6306 35.1016 11.6306C35.693 11.6306 36.2449 11.5123 36.7969 11.3152C37.3094 11.118 37.7431 10.8026 38.1374 10.4083C38.5316 10.0535 38.8076 9.61981 39.0442 9.10728C39.2413 8.59474 39.3595 8.08221 39.3595 7.53025C39.3201 6.97829 39.2018 6.42633 38.9653 5.95322ZM37.1911 8.39769C37.0729 8.67367 36.9152 8.91015 36.718 9.10728C36.5209 9.3044 36.2449 9.46218 35.9689 9.58046C35.693 9.69874 35.3775 9.73812 35.0621 9.73812C34.7467 9.73812 34.4708 9.69874 34.1948 9.58046C33.9188 9.46218 33.6822 9.3044 33.4851 9.10728C33.288 8.91015 33.1303 8.67367 33.012 8.39769C32.8937 8.12171 32.8543 7.84565 32.8543 7.53025C32.8543 7.25427 32.9332 6.93892 33.012 6.70237C33.1303 6.42639 33.288 6.18981 33.4851 5.99268C33.6822 5.79556 33.9188 5.63787 34.1948 5.5196C34.4708 5.40132 34.7467 5.36184 35.0621 5.36184C35.3775 5.36184 35.6535 5.44074 35.9689 5.5196C36.2449 5.63787 36.4815 5.79556 36.718 5.99268C36.9152 6.18981 37.0729 6.42639 37.1911 6.70237C37.3094 6.97835 37.3883 7.25427 37.3883 7.53025C37.3883 7.84565 37.3094 8.12171 37.1911 8.39769Z"
      fill="#FF9600"
    />
    <path
      d="M42.2517 4.38897C42.7742 4.38897 43.1979 3.96538 43.1979 3.4428C43.1979 2.92021 42.7742 2.49652 42.2517 2.49652C41.7291 2.49652 41.3055 2.92021 41.3055 3.4428C41.3055 3.96538 41.7291 4.38897 42.2517 4.38897Z"
      fill="#FF9600"
    />
    <path
      d="M41.3055 5.36188H43.1979V11.6305H41.3055V5.36188Z"
      fill="#FF9600"
    />
    <path
      d="M45.1438 11.6306V9.69875L49.2835 5.44076H45.2621V3.58777H52.0433V5.51959L47.9036 9.73812H52.1616V11.5911L45.1438 11.6306Z"
      fill="#FF9600"
    />
    <path
      d="M55.0538 11.6306C55.5764 11.6306 56 11.2069 56 10.6843C56 10.1617 55.5764 9.7381 55.0538 9.7381C54.5312 9.7381 54.1076 10.1617 54.1076 10.6843C54.1076 11.2069 54.5312 11.6306 55.0538 11.6306Z"
      fill="#FF9600"
    />
  </svg>
);

const LetterMail = () => (
  <svg
    width="166"
    height="173"
    viewBox="0 0 166 173"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 167.5V61.5526C1.75 60.2641 2.37073 59.0544 3.41751 58.3031L80.9103 2.6794C82.3078 1.67628 84.1902 1.67903 85.5848 2.68622L162.592 58.3025C163.633 59.0545 164.25 60.2608 164.25 61.5452V167.5C164.25 169.709 162.459 171.5 160.25 171.5H5.75C3.54086 171.5 1.75 169.709 1.75 167.5Z"
      fill="#F3F4F6"
      stroke="black"
      strokeWidth="2"
    />
    <g clipPath="url(#clip0_262_70657)">
      <rect
        x="10.75"
        y="30"
        width="144"
        height="101"
        rx="2"
        fill="white"
        stroke="black"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.75 41C29.75 39.8954 30.6454 39 31.75 39H136.75C137.855 39 138.75 39.8954 138.75 41C138.75 42.1046 137.855 43 136.75 43H31.75C30.6454 43 29.75 42.1046 29.75 41ZM29.75 51C29.75 49.8954 30.6454 49 31.75 49H136.75C137.855 49 138.75 49.8954 138.75 51C138.75 52.1046 137.855 53 136.75 53H31.75C30.6454 53 29.75 52.1046 29.75 51ZM31.75 59C30.6454 59 29.75 59.8954 29.75 61C29.75 62.1046 30.6454 63 31.75 63H136.75C137.855 63 138.75 62.1046 138.75 61C138.75 59.8954 137.855 59 136.75 59H31.75ZM29.75 71C29.75 69.8954 30.6454 69 31.75 69H136.75C137.855 69 138.75 69.8954 138.75 71C138.75 72.1046 137.855 73 136.75 73H31.75C30.6454 73 29.75 72.1046 29.75 71ZM31.75 79C30.6454 79 29.75 79.8954 29.75 81C29.75 82.1046 30.6454 83 31.75 83H136.75C137.855 83 138.75 82.1046 138.75 81C138.75 79.8954 137.855 79 136.75 79H31.75ZM29.75 91C29.75 89.8954 30.6454 89 31.75 89H136.75C137.855 89 138.75 89.8954 138.75 91C138.75 92.1046 137.855 93 136.75 93H31.75C30.6454 93 29.75 92.1046 29.75 91ZM31.75 99C30.6454 99 29.75 99.8954 29.75 101C29.75 102.105 30.6454 103 31.75 103H136.75C137.855 103 138.75 102.105 138.75 101C138.75 99.8954 137.855 99 136.75 99H31.75ZM29.75 111C29.75 109.895 30.6454 109 31.75 109H136.75C137.855 109 138.75 109.895 138.75 111C138.75 112.105 137.855 113 136.75 113H31.75C30.6454 113 29.75 112.105 29.75 111ZM31.75 119C30.6454 119 29.75 119.895 29.75 121C29.75 122.105 30.6454 123 31.75 123H136.75C137.855 123 138.75 122.105 138.75 121C138.75 119.895 137.855 119 136.75 119H31.75Z"
        fill="#D9D9D9"
      />
    </g>
    <path
      d="M83.2728 112.744L3.22282 69.7903C2.55663 69.4328 1.75 69.9154 1.75 70.6715V167.551C1.75 167.837 1.87215 168.109 2.08564 168.298L5.96584 171.747C6.14889 171.91 6.38529 172 6.6302 172H161.106C161.498 172 161.854 171.771 162.016 171.414L164.16 166.697C164.219 166.567 164.25 166.426 164.25 166.283V70.6862C164.25 69.9268 163.437 69.4445 162.77 69.8087L84.2252 112.74C83.9287 112.902 83.5705 112.904 83.2728 112.744Z"
      fill="#F3F4F6"
    />
    <path
      d="M3.23975 68.8368L82.75 113.5L162.26 68.8368C162.927 68.4624 163.75 68.9441 163.75 69.7087V157.291C163.75 158.056 162.927 158.538 162.26 158.163L82.75 113.5L3.23975 158.163C2.57315 158.538 1.75 158.056 1.75 157.291V69.7087C1.75 68.9441 2.57315 68.4624 3.23975 68.8368Z"
      fill="#F3F4F6"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M109.75 113.5C109.75 128.102 97.4718 140 82.25 140C67.0282 140 54.75 128.102 54.75 113.5C54.75 98.8978 67.0282 87 82.25 87C97.4718 87 109.75 98.8978 109.75 113.5Z"
      fill="#FF9600"
      stroke="#374151"
      strokeWidth="2"
    />
    <path
      d="M1.75 59.5V167.5C1.75 169.709 3.54086 171.5 5.75 171.5H160.25C162.459 171.5 164.25 169.709 164.25 167.5V59.5"
      stroke="black"
      strokeWidth="2"
    />
    <defs>
      <clipPath id="clip0_262_70657">
        <rect
          width="146"
          height="103"
          fill="white"
          transform="translate(9.75 29)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Information = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00004 13.6667C3.31804 13.6667 0.333374 10.682 0.333374 7C0.333374 3.318 3.31804 0.333336 7.00004 0.333336C10.682 0.333336 13.6667 3.318 13.6667 7C13.6667 10.682 10.682 13.6667 7.00004 13.6667ZM6.33337 9V10.3333H7.66671V9H6.33337ZM6.33337 3.66667V7.66667H7.66671V3.66667H6.33337Z"
      fill={color}
    />
  </svg>
);

const NoShowPassword = ({ wh, color, strokeW }) => (
  <svg
    width={wh}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 1L5.58916 4.58916M20 19L16.4112 15.4112M12.8749 16.8246C12.2677 16.9398 11.6411 17 11.0005 17C6.52281 17 2.73251 14.0571 1.45825 9.99997C1.80515 8.8955 2.33851 7.87361 3.02143 6.97118M8.87868 7.87868C9.42157 7.33579 10.1716 7 11 7C12.6569 7 14 8.34315 14 10C14 10.8284 13.6642 11.5784 13.1213 12.1213M8.87868 7.87868L13.1213 12.1213M8.87868 7.87868L5.58916 4.58916M13.1213 12.1213L5.58916 4.58916M13.1213 12.1213L16.4112 15.4112M5.58916 4.58916C7.14898 3.58354 9.00656 3 11.0004 3C15.4781 3 19.2684 5.94291 20.5426 10C19.8357 12.2507 18.3545 14.1585 16.4112 15.4112"
      stroke={color}
      strokeWidth={strokeW}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShowPassword = ({ wh, color, strokeW }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 7.00033C11.5 8.38104 10.3807 9.50033 9 9.50033C7.61929 9.50033 6.5 8.38104 6.5 7.00033C6.5 5.61961 7.61929 4.50033 9 4.50033C10.3807 4.50033 11.5 5.61961 11.5 7.00033Z"
      stroke={color}
      strokeWidth={strokeW}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.04855 7.0003C2.11044 3.61939 5.26901 1.16699 9.00037 1.16699C12.7317 1.16699 15.8903 3.61942 16.9522 7.00036C15.8903 10.3813 12.7317 12.8337 9.00039 12.8337C5.26901 12.8337 2.11042 10.3812 1.04855 7.0003Z"
      stroke={color}
      strokeWidth={strokeW}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const InterrogationCercle = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.103 13.821C11.103 14.1011 11.33 14.3281 11.6101 14.3281H12.2514C12.5315 14.3281 12.7585 14.1011 12.7585 13.821C12.7685 12.7671 13.1115 12.6626 13.9219 12.1655C14.8366 11.6186 15.4084 10.8729 15.4084 9.73438C15.4084 8.05398 14.1009 7 12.2017 7C10.7651 7 9.5521 7.65745 9.14478 8.94997C8.99363 9.42962 9.41484 9.85369 9.91774 9.85369C10.3948 9.85369 10.7517 9.44423 11.0219 9.05104C11.2899 8.66109 11.7356 8.47159 12.1918 8.47159C12.9524 8.47159 13.5639 8.97869 13.5639 9.75923C13.5639 10.4553 13.1016 10.9325 12.5 11.3104C11.62 11.8572 11.1129 12.0313 11.103 13.821ZM11.973 17.4304C12.5597 17.4304 13.0618 16.9432 13.0668 16.3366C13.0618 15.7401 12.5597 15.2528 11.973 15.2528C11.3665 15.2528 10.8743 15.7401 10.8793 16.3366C10.8743 16.9432 11.3665 17.4304 11.973 17.4304Z"
      fill={color}
    />
  </svg>
);

const ValidationCercle = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10L9 12L13 8M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MenuBar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 cursor-pointer md:hidden block"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
);

const Help = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.103 13.821C11.103 14.1011 11.33 14.3281 11.6101 14.3281H12.2514C12.5315 14.3281 12.7585 14.1011 12.7585 13.821C12.7685 12.7671 13.1115 12.6626 13.9219 12.1655C14.8366 11.6186 15.4084 10.8729 15.4084 9.73438C15.4084 8.05398 14.1009 7 12.2017 7C10.7651 7 9.5521 7.65745 9.14478 8.94997C8.99363 9.42962 9.41484 9.85369 9.91774 9.85369C10.3948 9.85369 10.7517 9.44423 11.0219 9.05104C11.2899 8.66109 11.7356 8.47159 12.1918 8.47159C12.9524 8.47159 13.5639 8.97869 13.5639 9.75923C13.5639 10.4553 13.1016 10.9325 12.5 11.3104C11.62 11.8572 11.1129 12.0313 11.103 13.821ZM11.973 17.4304C12.5597 17.4304 13.0618 16.9432 13.0668 16.3366C13.0618 15.7401 12.5597 15.2528 11.973 15.2528C11.3665 15.2528 10.8743 15.7401 10.8793 16.3366C10.8743 16.9432 11.3665 17.4304 11.973 17.4304Z"
      fill={color}
    />
  </svg>
);

const Logout = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1667 11.3334L16.5 8.00004M16.5 8.00004L13.1667 4.66671M16.5 8.00004L4.83333 8.00004M9.83333 11.3334V12.1667C9.83333 13.5474 8.71405 14.6667 7.33333 14.6667H4C2.61929 14.6667 1.5 13.5474 1.5 12.1667V3.83337C1.5 2.45266 2.61929 1.33337 4 1.33337H7.33333C8.71405 1.33337 9.83333 2.45266 9.83333 3.83337V4.66671"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronRightNav = ({ prop }) => (
  <svg
    className={prop}
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.999999 1.16668L6.83333 7.00001L1 12.8333"
      stroke="#374151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronLeftNav = () => (
  <svg
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 13.3116L1.66667 7.47826L7.5 1.64493"
      stroke="#374151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchLoop = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DashboardIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7V5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 13C4 12.4477 4.44772 12 5 12H11C11.5523 12 12 12.4477 12 13V19C12 19.5523 11.5523 20 11 20H5C4.44772 20 4 19.5523 4 19V13Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 13C16 12.4477 16.4477 12 17 12H19C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V13Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ProfilIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 4.66667C10.6667 6.13943 9.47275 7.33333 8 7.33333C6.52724 7.33333 5.33333 6.13943 5.33333 4.66667C5.33333 3.19391 6.52724 2 8 2C9.47275 2 10.6667 3.19391 10.6667 4.66667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.33337C5.42267 9.33337 3.33333 11.4227 3.33333 14H12.6667C12.6667 11.4227 10.5773 9.33337 8 9.33337Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1818_13335)">
      <path
        d="M13 30L17.9 25.1L13 30ZM17.9 25.1C18.4 25.7 19.2 26 20 26C21.7 26 23 24.7 23 23C23 21.3 21.7 20 20 20C18.3 20 17 21.3 17 23C17 23.8 17.3 24.6 17.9 25.1Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27 14H25V13C25 11.3 23.7 10 22 10H18C16.3 10 15 11.3 15 13V14H13C11.3 14 10 15.3 10 17V27C10 27.8 10.3 28.5 10.8 29C11.2 28.5 11.7 28.1 12.2 27.6C12.1 27.5 12 27.2 12 27V23.7C13 24 14 24.3 15 24.5C14.9 24.1 14.8 23.6 14.8 23.2C14.8 22.9 14.8 22.7 14.8 22.4C13.9 22.2 12.9 21.9 12 21.6V17C12 16.4 12.4 16 13 16H27C27.6 16 28 16.4 28 17V21.6C27 22 26 22.2 25 22.4C25.1 22.7 25.1 23 25.2 23.3C25.2 23.7 25.2 24 25.1 24.4C26.1 24.2 27 24 28 23.7V27C28 27.6 27.6 28 27 28H18C17.9 28.1 17.8 28.3 17.7 28.4C17.6 28.5 17.5 28.5 17.4 28.6C16.9 29 16.4 29.5 16 30.1H27C28.7 30.1 30 28.8 30 27.1V17C30 15.3 28.7 14 27 14ZM23 14H17V13C17 12.4 17.4 12 18 12H22C22.6 12 23 12.4 23 13V14Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1818_13335">
        <rect width={wh} height={wh} fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

const DocumentIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MissionIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 13.2554C18.2207 14.3805 15.1827 15 12 15C8.8173 15 5.7793 14.3805 3 13.2554M16 6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6M12 12H12.01M5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HelpIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29 20C29 24.9706 24.9706 29 20 29C15.0294 29 11 24.9706 11 20C11 15.0294 15.0294 11 20 11C24.9706 11 29 15.0294 29 20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.103 21.821C19.103 22.1011 19.33 22.3281 19.6101 22.3281H20.2514C20.5315 22.3281 20.7585 22.1011 20.7585 21.821V21.821C20.7685 20.7671 21.1115 20.6626 21.9219 20.1655C22.8366 19.6186 23.4084 18.8729 23.4084 17.7344C23.4084 16.054 22.1009 15 20.2017 15C18.7651 15 17.5521 15.6575 17.1448 16.95C16.9936 17.4296 17.4148 17.8537 17.9177 17.8537V17.8537C18.3948 17.8537 18.7517 17.4442 19.0219 17.051C19.2899 16.6611 19.7356 16.4716 20.1918 16.4716C20.9524 16.4716 21.5639 16.9787 21.5639 17.7592C21.5639 18.4553 21.1016 18.9325 20.5 19.3104C19.62 19.8572 19.1129 20.0313 19.103 21.821V21.821ZM19.973 25.4304C20.5597 25.4304 21.0618 24.9432 21.0668 24.3366C21.0618 23.7401 20.5597 23.2528 19.973 23.2528C19.3665 23.2528 18.8743 23.7401 18.8793 24.3366C18.8743 24.9432 19.3665 25.4304 19.973 25.4304Z"
      fill={color}
    />
  </svg>
);

const AddVivier = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_4370)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 6H19C20.7 6 22 7.3 22 9V19.1C22 20.8 20.7 22.1 19 22.1H15.5371C15.7814 21.4389 15.9353 20.7338 15.9836 20H19C19.6 20 20 19.6 20 19V15.7C19 16 18.1 16.2 17.1 16.4C17.2 16 17.2 15.7 17.2 15.3V15.3C17.15 15.15 17.125 15 17.1 14.85C17.075 14.7 17.05 14.55 17 14.4C18 14.2 19 14 20 13.6V9C20 8.4 19.6 8 19 8H5C4.4 8 4 8.4 4 9V13.4995C3.19073 14.1073 2.50843 14.8751 2 15.7558V9C2 7.3 3.3 6 5 6H7V5C7 3.3 8.3 2 10 2H14C15.7 2 17 3.3 17 5V6ZM9 6H15V5C15 4.4 14.6 4 14 4H10C9.4 4 9 4.4 9 5V6Z"
        fill={'#ffffff'}
      />
    </g>
    <path
      d="M9.5 14V17.5M9.5 17.5V21M9.5 17.5H13M9.5 17.5L6 17.5"
      stroke={'#ffffff'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_10_4370">
        <rect width="20" height="21" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

const Add = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 6.5V9M8.5 9V11.5M8.5 9H11M8.5 9H6M16 9C16 13.1421 12.6421 16.5 8.5 16.5C4.35786 16.5 1 13.1421 1 9C1 4.85786 4.35786 1.5 8.5 1.5C12.6421 1.5 16 4.85786 16 9Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Import = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33398 11.3333L1.33398 12.1667C1.33398 13.5474 2.45327 14.6667 3.83398 14.6667L12.1673 14.6667C13.548 14.6667 14.6673 13.5474 14.6673 12.1667L14.6673 11.3333M11.334 4.66666L8.00065 1.33333M8.00065 1.33333L4.66732 4.66666M8.00065 1.33333L8.00065 11.3333"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LinkIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5237 8.47631C10.2219 7.17456 8.11139 7.17456 6.80964 8.47631L3.47631 11.8096C2.17456 13.1114 2.17456 15.2219 3.47631 16.5237C4.77806 17.8254 6.88861 17.8254 8.19036 16.5237L9.10832 15.6057M8.47631 11.5237C9.77806 12.8254 11.8886 12.8254 13.1904 11.5237L16.5237 8.19036C17.8254 6.88861 17.8254 4.77806 16.5237 3.47631C15.2219 2.17456 13.1114 2.17456 11.8096 3.47631L10.8933 4.39265"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Dots = ({ w, h, color }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 17 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66671 1.99996H2.67504M8.50004 1.99996H8.50837M14.3334 1.99996H14.3417M3.50004 1.99996C3.50004 2.4602 3.12694 2.83329 2.66671 2.83329C2.20647 2.83329 1.83337 2.4602 1.83337 1.99996C1.83337 1.53972 2.20647 1.16663 2.66671 1.16663C3.12694 1.16663 3.50004 1.53972 3.50004 1.99996ZM9.33337 1.99996C9.33337 2.4602 8.96028 2.83329 8.50004 2.83329C8.0398 2.83329 7.66671 2.4602 7.66671 1.99996C7.66671 1.53972 8.0398 1.16663 8.50004 1.16663C8.96028 1.16663 9.33337 1.53972 9.33337 1.99996ZM15.1667 1.99996C15.1667 2.4602 14.7936 2.83329 14.3334 2.83329C13.8731 2.83329 13.5 2.4602 13.5 1.99996C13.5 1.53972 13.8731 1.16663 14.3334 1.16663C14.7936 1.16663 15.1667 1.53972 15.1667 1.99996Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Modify = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2678 1.73223L18.9749 1.02513V1.02513L18.2678 1.73223ZM4.50006 19.0355V20.0355C4.76528 20.0355 5.01963 19.9301 5.20717 19.7426L4.50006 19.0355ZM1.00006 19.0355H6.10352e-05C6.10352e-05 19.5878 0.447776 20.0355 1.00006 20.0355L1.00006 19.0355ZM1.00006 15.4644L0.292954 14.7573C0.105418 14.9448 6.10352e-05 15.1992 6.10352e-05 15.4644H1.00006ZM15.4393 2.43934C16.0251 1.85355 16.9749 1.85355 17.5607 2.43934L18.9749 1.02513C17.608 -0.341709 15.392 -0.341709 14.0251 1.02513L15.4393 2.43934ZM17.5607 2.43934C18.1465 3.02513 18.1465 3.97487 17.5607 4.56066L18.9749 5.97487C20.3417 4.60804 20.3417 2.39196 18.9749 1.02513L17.5607 2.43934ZM17.5607 4.56066L3.79295 18.3284L5.20717 19.7426L18.9749 5.97487L17.5607 4.56066ZM4.50006 18.0355H1.00006V20.0355H4.50006V18.0355ZM14.0251 1.02513L0.292954 14.7573L1.70717 16.1715L15.4393 2.43934L14.0251 1.02513ZM6.10352e-05 15.4644V19.0355H2.00006V15.4644H6.10352e-05ZM12.5251 3.93934L16.0607 7.47487L17.4749 6.06066L13.9393 2.52513L12.5251 3.93934Z"
      fill={color}
    />
  </svg>
);

const Delete = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 5L15.1327 17.1425C15.0579 18.1891 14.187 19 13.1378 19H4.86224C3.81296 19 2.94208 18.1891 2.86732 17.1425L2 5M7 9V15M11 9V15M12 5V2C12 1.44772 11.5523 1 11 1H7C6.44772 1 6 1.44772 6 2V5M1 5H17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronTop = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 15L12 8L19 15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CardVitale = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 12.5V17C3 18.1046 3.89543 19 5 19H9.5M3 12.5V8C3 6.89543 3.89543 6 5 6H14H19C20.1046 6 21 6.89543 21 8V17C21 18.1046 20.1046 19 19 19H9.5M3 12.5L9.5 19M6 9.5H9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8293 13C15.9339 13 16.8293 12.1046 16.8293 11C16.8293 9.89543 15.9339 9 14.8293 9C13.7248 9 12.8293 9.89543 12.8293 11C12.8293 12.1046 13.7248 13 14.8293 13ZM14.8293 13C16.1356 13 17.2468 13.8348 17.6586 15M14.8293 13C13.5231 13 12.4118 13.8348 12 15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CardIdentity = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 12.5V17C3 18.1046 3.89543 19 5 19H9.5M3 12.5V8C3 6.89543 3.89543 6 5 6H14H19C20.1046 6 21 6.89543 21 8V17C21 18.1046 20.1046 19 19 19H9.5M3 12.5L9.5 19M6 9.5H9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8293 13C15.9339 13 16.8293 12.1046 16.8293 11C16.8293 9.89543 15.9339 9 14.8293 9C13.7248 9 12.8293 9.89543 12.8293 11C12.8293 12.1046 13.7248 13 14.8293 13ZM14.8293 13C16.1356 13 17.2468 13.8348 17.6586 15M14.8293 13C13.5231 13 12.4118 13.8348 12 15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CardProofAddress = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12L8.88889 11.1111M8.88889 11.1111L12 8L15.1111 11.1111M8.88889 11.1111V15.5556C8.88889 15.801 9.08787 16 9.33333 16H10.6667C10.9121 16 11.1111 15.801 11.1111 15.5556V13.7778C11.1111 13.5323 11.3101 13.3333 11.5556 13.3333H12.4444C12.6899 13.3333 12.8889 13.5323 12.8889 13.7778V15.5556C12.8889 15.801 13.0879 16 13.3333 16H14.6667C14.9121 16 15.1111 15.801 15.1111 15.5556V11.1111M15.1111 11.1111L16 12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CardBank = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_4366)">
      <path
        d="M7 20.6235H17C18.1046 20.6235 19 19.7281 19 18.6235V9.03775C19 8.77253 18.8946 8.51818 18.7071 8.33064L13.2929 2.91643C13.1054 2.72889 12.851 2.62354 12.5858 2.62354H7C5.89543 2.62354 5 3.51897 5 4.62354V18.6235C5 19.7281 5.89543 20.6235 7 20.6235Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15.305C13.8516 17.0624 11.9898 17.0624 10.8414 15.305C9.69309 13.5477 9.69309 10.6984 10.8414 8.94107C11.9898 7.18371 13.8516 7.18371 15 8.94107M9 10.773H12.9207M9 13.473H12.9207"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_4366">
        <rect width={wh} height={wh} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CardMeeting = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.22792 3.68377L8.27924 4L8.27924 4L9.22792 3.68377ZM10.7257 8.17721L9.77705 8.49344L10.7257 8.17721ZM10.2243 9.38787L10.6715 10.2823L10.6715 10.2823L10.2243 9.38787ZM7.96701 10.5165L7.51979 9.62207C7.03975 9.86209 6.83479 10.4383 7.05538 10.9275L7.96701 10.5165ZM13.4835 16.033L13.0725 16.9446C13.5618 17.1652 14.1379 16.9602 14.3779 16.4802L13.4835 16.033ZM14.6121 13.7757L13.7177 13.3285L14.6121 13.7757ZM15.8228 13.2743L15.5066 14.2229L15.5066 14.2229L15.8228 13.2743ZM20.3162 14.7721L20.6325 13.8234L20.3162 14.7721ZM5 2C3.34315 2 2 3.34315 2 5H4C4 4.44772 4.44772 4 5 4V2ZM8.27924 2H5V4H8.27924V2ZM10.1766 3.36755C9.90438 2.55086 9.1401 2 8.27924 2V4L8.27924 4L10.1766 3.36755ZM11.6744 7.86098L10.1766 3.36754L8.27924 4L9.77705 8.49344L11.6744 7.86098ZM10.6715 10.2823C11.5617 9.83718 11.9892 8.80521 11.6744 7.86098L9.77705 8.49344L9.77705 8.49344L10.6715 10.2823ZM8.41422 11.4109L10.6715 10.2823L9.77705 8.49344L7.51979 9.62207L8.41422 11.4109ZM13.8945 15.1214C11.6721 14.1194 9.88063 12.3279 8.87863 10.1055L7.05538 10.9275C8.25786 13.5946 10.4054 15.7421 13.0725 16.9446L13.8945 15.1214ZM13.7177 13.3285L12.5891 15.5858L14.3779 16.4802L15.5066 14.2229L13.7177 13.3285ZM16.139 12.3256C15.1948 12.0108 14.1628 12.4383 13.7177 13.3285L15.5066 14.2229L15.5066 14.2229L16.139 12.3256ZM20.6325 13.8234L16.139 12.3256L15.5066 14.2229L20 15.7208L20.6325 13.8234ZM22 15.7208C22 14.8599 21.4491 14.0956 20.6325 13.8234L20 15.7208H22ZM22 19V15.7208H20V19H22ZM19 22C20.6569 22 22 20.6569 22 19H20C20 19.5523 19.5523 20 19 20V22ZM18 22H19V20H18V22ZM2 6C2 14.8366 9.16344 22 18 22V20C10.268 20 4 13.732 4 6H2ZM2 5V6H4V5H2Z"
      fill={color}
    />
  </svg>
);

const Cadenas = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00016 11.5V13.1667M3.00016 16.5H13.0002C13.9206 16.5 14.6668 15.7538 14.6668 14.8333V9.83333C14.6668 8.91286 13.9206 8.16667 13.0002 8.16667H3.00016C2.07969 8.16667 1.3335 8.91286 1.3335 9.83333V14.8333C1.3335 15.7538 2.07969 16.5 3.00016 16.5ZM11.3335 8.16667V4.83333C11.3335 2.99238 9.84111 1.5 8.00016 1.5C6.15921 1.5 4.66683 2.99238 4.66683 4.83333V8.16667H11.3335Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const Metier = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 11.046C14.1839 11.9836 11.6523 12.4998 9 12.4998C6.34775 12.4998 3.81608 11.9836 1.5 11.046M12.3333 4.99984V3.33317C12.3333 2.4127 11.5871 1.6665 10.6667 1.6665H7.33333C6.41286 1.6665 5.66667 2.4127 5.66667 3.33317V4.99984M9 9.99984H9.00833M3.16667 16.6665H14.8333C15.7538 16.6665 16.5 15.9203 16.5 14.9998V6.6665C16.5 5.74603 15.7538 4.99984 14.8333 4.99984H3.16667C2.24619 4.99984 1.5 5.74603 1.5 6.6665V14.9998C1.5 15.9203 2.24619 16.6665 3.16667 16.6665Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Calendar = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Euro = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.12132 9.53553C5.94975 11.4882 4.05025 11.4882 2.87868 9.53553C1.70711 7.58291 1.70711 4.41709 2.87868 2.46447C4.05025 0.511845 5.94975 0.511845 7.12132 2.46447M1 4.5H5M1 7.5H5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Drapeau = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 19V15M1 15V3C1 1.89543 1.89543 1 3 1H9.5L10.5 2H19L16 8L19 14H10.5L9.5 13H3C1.89543 13 1 13.8954 1 15ZM10 1.5V7"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Warning = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00003 6.5V8.16667M9.00003 11.5H9.00836M3.22653 14.8333H14.7735C16.0565 14.8333 16.8584 13.4444 16.2169 12.3333L10.4434 2.33333C9.8019 1.22222 8.19815 1.22222 7.55665 2.33333L1.78315 12.3333C1.14165 13.4444 1.94353 14.8333 3.22653 14.8333Z"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Camion = ({ w, h, color }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.83346 10.3333H10.7085H9.83346ZM9.83346 3.66667H8.95846V3.66667L9.83346 3.66667ZM13.4109 3.07742L14.0296 2.4587L14.0296 2.4587L13.4109 3.07742ZM16.256 5.92259L16.8748 5.30388L16.8748 5.30388L16.256 5.92259ZM2.33346 2.04167H9.00012V0.291672H2.33346V2.04167ZM8.95846 2.00001V10.3333H10.7085V2.00001H8.95846ZM2.37512 10.3333V2H0.625122V10.3333H2.37512ZM3.16679 10.2917H2.33346V12.0417H3.16679V10.2917ZM9.00012 10.2917H6.50012V12.0417H9.00012V10.2917ZM0.625122 10.3333C0.625122 11.2768 1.38997 12.0417 2.33346 12.0417V10.2917C2.35647 10.2917 2.37512 10.3103 2.37512 10.3333H0.625122ZM8.95846 10.3333C8.95846 10.3103 8.97711 10.2917 9.00012 10.2917V12.0417C9.94361 12.0417 10.7085 11.2768 10.7085 10.3333H8.95846ZM9.00012 2.04167C8.97711 2.04167 8.95846 2.02302 8.95846 2.00001H10.7085C10.7085 1.05652 9.94361 0.291672 9.00012 0.291672V2.04167ZM2.33346 0.291672C1.38997 0.291672 0.625122 1.05652 0.625122 2H2.37512C2.37512 2.02302 2.35647 2.04167 2.33346 2.04167V0.291672ZM10.7085 10.3333L10.7085 3.66667L8.95846 3.66667L8.95846 10.3333H10.7085ZM10.6668 3.70834H12.8216V1.95834H10.6668V3.70834ZM15.6251 6.51185V10.3333H17.3751V6.51185H15.6251ZM12.7921 3.69613L15.6373 6.54131L16.8748 5.30388L14.0296 2.4587L12.7921 3.69613ZM11.5001 10.2917H10.6668V12.0417H11.5001V10.2917ZM15.6668 10.2917H14.8335V12.0417H15.6668V10.2917ZM17.3751 6.51185C17.3751 6.05877 17.1951 5.62425 16.8748 5.30388L15.6373 6.54131C15.6295 6.5335 15.6251 6.5229 15.6251 6.51185H17.3751ZM12.8216 3.70834C12.8106 3.70834 12.8 3.70395 12.7921 3.69614L14.0296 2.4587C13.7092 2.13832 13.2747 1.95834 12.8216 1.95834V3.70834ZM8.95846 10.3333C8.95846 11.2768 9.7233 12.0417 10.6668 12.0417V10.2917C10.6898 10.2917 10.7085 10.3103 10.7085 10.3333H8.95846ZM15.6251 10.3333C15.6251 10.3103 15.6438 10.2917 15.6668 10.2917V12.0417C16.6103 12.0417 17.3751 11.2768 17.3751 10.3333H15.6251ZM10.7085 3.66667C10.7085 3.68968 10.6898 3.70834 10.6668 3.70834V1.95834C9.7233 1.95834 8.95846 2.72319 8.95846 3.66667H10.7085ZM5.62512 11.1667C5.62512 11.6039 5.27068 11.9583 4.83345 11.9583V13.7083C6.23718 13.7083 7.37512 12.5704 7.37512 11.1667H5.62512ZM4.83345 11.9583C4.39623 11.9583 4.04179 11.6039 4.04179 11.1667H2.29179C2.29179 12.5704 3.42973 13.7083 4.83345 13.7083V11.9583ZM4.04179 11.1667C4.04179 10.7294 4.39623 10.375 4.83345 10.375V8.62501C3.42973 8.62501 2.29179 9.76295 2.29179 11.1667H4.04179ZM4.83345 10.375C5.27068 10.375 5.62512 10.7294 5.62512 11.1667H7.37512C7.37512 9.76295 6.23718 8.62501 4.83345 8.62501V10.375ZM13.9585 11.1667C13.9585 11.6039 13.604 11.9583 13.1668 11.9583V13.7083C14.5705 13.7083 15.7085 12.5704 15.7085 11.1667H13.9585ZM13.1668 11.9583C12.7296 11.9583 12.3751 11.6039 12.3751 11.1667H10.6251C10.6251 12.5704 11.7631 13.7083 13.1668 13.7083V11.9583ZM12.3751 11.1667C12.3751 10.7294 12.7296 10.375 13.1668 10.375V8.62501C11.7631 8.62501 10.6251 9.76295 10.6251 11.1667H12.3751ZM13.1668 10.375C13.604 10.375 13.9585 10.7294 13.9585 11.1667H15.7085C15.7085 9.76295 14.5705 8.62501 13.1668 8.62501V10.375Z"
      fill={color}
    />
  </svg>
);

const Loading = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.18182 11.5C8.18182 11.0231 7.79514 10.6364 7.31818 10.6364H3.86364C3.38668 10.6364 3 11.0231 3 11.5C3 11.977 3.38668 12.3637 3.86364 12.3637H7.31818C7.79514 12.3637 8.18182 11.977 8.18182 11.5Z"
      fill={color}
    />
    <path
      d="M20.2727 10.6364H18.5455C18.0685 10.6364 17.6818 11.0231 17.6818 11.5C17.6818 11.977 18.0685 12.3637 18.5455 12.3637H20.2727C20.7497 12.3637 21.1364 11.977 21.1364 11.5C21.1364 11.0231 20.7497 10.6364 20.2727 10.6364Z"
      fill={color}
    />
    <path
      d="M12.5 7.18182C12.9769 7.18182 13.3636 6.79514 13.3636 6.31818V2.86364C13.3636 2.38668 12.9769 2 12.5 2C12.023 2 11.6364 2.38668 11.6364 2.86364V6.31818C11.6364 6.79514 12.023 7.18182 12.5 7.18182Z"
      fill={color}
    />
    <path
      d="M12.5 15.8182C12.0231 15.8182 11.6364 16.2049 11.6364 16.6818V20.1364C11.6364 20.6133 12.0231 21 12.5 21C12.977 21 13.3637 20.6133 13.3637 20.1364V16.6818C13.3637 16.2049 12.977 15.8182 12.5 15.8182Z"
      fill={color}
    />
    <path
      d="M7.00379 4.78245C6.66663 4.44517 6.11978 4.44523 5.78244 4.78245C5.44516 5.11973 5.44516 5.66652 5.78244 6.0038L8.22521 8.44663C8.39385 8.61527 8.61488 8.69962 8.83585 8.69962C9.05683 8.69962 9.27792 8.61527 9.4465 8.44668C9.78378 8.10941 9.78378 7.56261 9.4465 7.22533L7.00379 4.78245Z"
      fill={color}
    />
    <path
      d="M16.7748 14.5534C16.4375 14.2162 15.8907 14.2162 15.5534 14.5534C15.2161 14.8907 15.2162 15.4375 15.5534 15.7748L17.9962 18.2175C18.1649 18.3861 18.3859 18.4704 18.6069 18.4704C18.828 18.4704 19.049 18.3861 19.2176 18.2175C19.5549 17.8802 19.5549 17.3334 19.2176 16.9961L16.7748 14.5534Z"
      fill={color}
    />
    <path
      d="M8.22521 14.5535L5.7825 16.9962C5.44522 17.3335 5.44522 17.8803 5.7825 18.2175C5.95114 18.3862 6.17217 18.4705 6.39321 18.4705C6.61424 18.4705 6.83527 18.3862 7.00385 18.2175L9.44656 15.7748C9.78384 15.4375 9.78384 14.8907 9.44656 14.5535C9.10929 14.2162 8.56243 14.2162 8.22521 14.5535Z"
      fill={color}
    />
  </svg>
);

const BankIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 12V15M10 12V15M14 12V15M1 19H19M1 8H19M1 5L10 1L19 5M2 8H18V19H2V8Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Exclamation = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Check = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 13L9 17L19 7"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const JustifyIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 19H13C14.1046 19 15 18.1046 15 17V7.41421C15 7.149 14.8946 6.89464 14.7071 6.70711L9.29289 1.29289C9.10536 1.10536 8.851 1 8.58579 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PhoneIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.22792 3.68377L8.27924 4L8.27924 4L9.22792 3.68377ZM10.7257 8.17721L9.77705 8.49344L10.7257 8.17721ZM10.2243 9.38787L10.6715 10.2823L10.6715 10.2823L10.2243 9.38787ZM7.96701 10.5165L7.51979 9.62207C7.03975 9.86209 6.83479 10.4383 7.05538 10.9275L7.96701 10.5165ZM13.4835 16.033L13.0725 16.9446C13.5618 17.1652 14.1379 16.9602 14.3779 16.4802L13.4835 16.033ZM14.6121 13.7757L13.7177 13.3285L14.6121 13.7757ZM15.8228 13.2743L15.5066 14.2229L15.5066 14.2229L15.8228 13.2743ZM20.3162 14.7721L20.6325 13.8234L20.3162 14.7721ZM5 2C3.34315 2 2 3.34315 2 5H4C4 4.44772 4.44772 4 5 4V2ZM8.27924 2H5V4H8.27924V2ZM10.1766 3.36755C9.90438 2.55086 9.1401 2 8.27924 2V4L8.27924 4L10.1766 3.36755ZM11.6744 7.86098L10.1766 3.36754L8.27924 4L9.77705 8.49344L11.6744 7.86098ZM10.6715 10.2823C11.5617 9.83718 11.9892 8.80521 11.6744 7.86098L9.77705 8.49344L9.77705 8.49344L10.6715 10.2823ZM8.41422 11.4109L10.6715 10.2823L9.77705 8.49344L7.51979 9.62207L8.41422 11.4109ZM13.8945 15.1214C11.6721 14.1194 9.88063 12.3279 8.87863 10.1055L7.05538 10.9275C8.25786 13.5946 10.4054 15.7421 13.0725 16.9446L13.8945 15.1214ZM13.7177 13.3285L12.5891 15.5858L14.3779 16.4802L15.5066 14.2229L13.7177 13.3285ZM16.139 12.3256C15.1948 12.0108 14.1628 12.4383 13.7177 13.3285L15.5066 14.2229L15.5066 14.2229L16.139 12.3256ZM20.6325 13.8234L16.139 12.3256L15.5066 14.2229L20 15.7208L20.6325 13.8234ZM22 15.7208C22 14.8599 21.4491 14.0956 20.6325 13.8234L20 15.7208H22ZM22 19V15.7208H20V19H22ZM19 22C20.6569 22 22 20.6569 22 19H20C20 19.5523 19.5523 20 19 20V22ZM18 22H19V20H18V22ZM2 6C2 14.8366 9.16344 22 18 22V20C10.268 20 4 13.732 4 6H2ZM2 5V6H4V5H2Z"
      fill={color}
    />
  </svg>
);

const Pencil = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2678 3.73223L20.9749 3.02513V3.02513L20.2678 3.73223ZM6.50006 21.0355V22.0355C6.76528 22.0355 7.01963 21.9301 7.20717 21.7426L6.50006 21.0355ZM3.00006 21.0355H2.00006C2.00006 21.5878 2.44778 22.0355 3.00006 22.0355V21.0355ZM3.00006 17.4644L2.29295 16.7573C2.10542 16.9448 2.00006 17.1992 2.00006 17.4644H3.00006ZM17.4393 4.43934C18.0251 3.85355 18.9749 3.85355 19.5607 4.43934L20.9749 3.02513C19.608 1.65829 17.392 1.65829 16.0251 3.02513L17.4393 4.43934ZM19.5607 4.43934C20.1465 5.02513 20.1465 5.97487 19.5607 6.56066L20.9749 7.97487C22.3417 6.60804 22.3417 4.39196 20.9749 3.02513L19.5607 4.43934ZM19.5607 6.56066L5.79295 20.3284L7.20717 21.7426L20.9749 7.97487L19.5607 6.56066ZM6.50006 20.0355H3.00006V22.0355H6.50006V20.0355ZM16.0251 3.02513L2.29295 16.7573L3.70717 18.1715L17.4393 4.43934L16.0251 3.02513ZM2.00006 17.4644V21.0355H4.00006V17.4644H2.00006ZM14.5251 5.93934L18.0607 9.47487L19.4749 8.06066L15.9393 4.52513L14.5251 5.93934Z"
      fill={color}
    />
  </svg>
);

const EmptyStateMission = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" rx="128" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_2354_9" transform="scale(0.00398406)" />
      </pattern>
      <image
        id="image0_2354_9"
        width="251"
        height="251"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const EmptyStateMissionSearch = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" rx="128" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_2354_3" transform="scale(0.00199203)" />
      </pattern>
      <image
        id="image0_2354_3"
        width="502"
        height="502"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const EmptyStateTimeRecord = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" rx="128" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_2354_29" transform="scale(0.00398406)" />
      </pattern>
      <image
        id="image0_2354_29"
        width="251"
        height="251"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const EmptyStateContract = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" rx="128" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_2354_69"
          transform="translate(-0.00199203) scale(0.00398406)"
        />
      </pattern>
      <image
        id="image0_2354_69"
        width="252"
        height="251"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const EmptyStatePayslip = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" rx="128" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_3185_12883" transform="scale(0.00398406)" />
      </pattern>
      <image
        id="image0_3185_12883"
        width="251"
        height="251"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const EmptyStateComingSoon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 953 953"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2559_12285)">
      <circle cx="476.5" cy="476.5" r="476.5" fill="#EFF0F5" />
      <path
        d="M478.055 384.045L205.028 444.718V770.834L478.055 710.161V384.045Z"
        fill="#9CA3AF"
      />
      <path
        d="M478.056 384.045L751.083 444.718V770.834L478.056 710.161V384.045Z"
        fill="#B1BABF"
      />
      <path
        d="M751.082 448.51L478.055 509.183V835.299L751.082 774.626V448.51Z"
        fill="#D3D9DD"
      />
      <path
        d="M205.028 448.51L478.055 509.183V835.299L205.028 774.626V448.51Z"
        fill="#E1E4E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M376.683 273.42C376.683 267.691 372.038 263.046 366.309 263.046C360.579 263.046 355.934 267.691 355.934 273.42L355.934 294.169H335.186C329.457 294.169 324.812 298.814 324.812 304.543C324.812 310.273 329.457 314.917 335.186 314.917H355.934L355.934 335.666C355.934 341.395 360.579 346.04 366.309 346.04C372.038 346.04 376.683 341.395 376.683 335.666V314.917H397.432C403.161 314.917 407.806 310.273 407.806 304.543C407.806 298.814 403.161 294.169 397.432 294.169H376.683V273.42Z"
        fill="#9CA3AF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M563.419 112.62C563.419 106.891 558.775 102.246 553.045 102.246C547.316 102.246 542.671 106.891 542.671 112.62L542.671 133.368H521.922C516.192 133.368 511.548 138.013 511.548 143.743C511.548 149.472 516.192 154.117 521.922 154.117H542.671L542.671 174.865C542.671 180.595 547.316 185.24 553.045 185.24C558.775 185.24 563.419 180.595 563.419 174.865V154.117H584.167C589.897 154.117 594.541 149.472 594.541 143.743C594.541 138.013 589.897 133.368 584.167 133.368H563.419V112.62Z"
        fill="#D3D9DD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M448.975 157.543C451.444 155.074 451.444 151.072 448.975 148.604C446.507 146.136 442.505 146.136 440.037 148.604L431.099 157.542L422.16 148.604C419.692 146.135 415.69 146.135 413.222 148.604C410.753 151.072 410.753 155.074 413.222 157.542L422.16 166.481L413.221 175.42C410.752 177.888 410.752 181.89 413.221 184.359C415.689 186.827 419.691 186.827 422.159 184.359L431.099 175.419L440.038 184.358C442.506 186.827 446.508 186.827 448.976 184.358C451.445 181.89 451.445 177.888 448.976 175.42L440.037 166.481L448.975 157.543Z"
        fill="#D3D9DD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M492.56 269.114C495.028 266.646 495.028 262.644 492.56 260.175C490.092 257.707 486.09 257.707 483.621 260.175L474.683 269.113L465.745 260.175C463.277 257.707 459.275 257.707 456.806 260.175C454.338 262.643 454.338 266.645 456.806 269.114L465.744 278.052L456.805 286.991C454.337 289.46 454.337 293.462 456.805 295.93C459.274 298.398 463.276 298.398 465.744 295.93L474.683 286.991L483.622 295.93C486.091 298.398 490.093 298.398 492.561 295.93C495.029 293.461 495.029 289.459 492.561 286.991L483.622 278.052L492.56 269.114Z"
        fill="#B1BABF"
      />
      <circle cx="558.232" cy="242.298" r="15.5613" fill="#E1E4E9" />
      <circle cx="615.289" cy="335.666" r="15.5613" fill="#E1E4E9" />
      <circle cx="470.051" cy="76.3103" r="15.5613" fill="#9CA3AF" />
    </g>
    <defs>
      <clipPath id="clip0_2559_12285">
        <rect width="953" height="953" rx="476.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DotsV = ({ w, h, color }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 4 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99992 2.16634L1.99992 2.17467M1.99992 7.99967L1.99992 8.00801M1.99992 13.833L1.99992 13.8413M1.99992 2.99967C1.53968 2.99967 1.16659 2.62658 1.16659 2.16634C1.16659 1.7061 1.53968 1.33301 1.99992 1.33301C2.46016 1.33301 2.83325 1.7061 2.83325 2.16634C2.83325 2.62658 2.46016 2.99967 1.99992 2.99967ZM1.99992 8.83301C1.53968 8.83301 1.16659 8.45991 1.16659 7.99967C1.16659 7.53944 1.53968 7.16634 1.99992 7.16634C2.46016 7.16634 2.83325 7.53944 2.83325 7.99967C2.83325 8.45991 2.46016 8.83301 1.99992 8.83301ZM1.99992 14.6663C1.53968 14.6663 1.16658 14.2932 1.16659 13.833C1.16659 13.3728 1.53968 12.9997 1.99992 12.9997C2.46016 12.9997 2.83325 13.3728 2.83325 13.833C2.83325 14.2932 2.46016 14.6663 1.99992 14.6663Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CreditCard = ({ w, h, color }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6H19M5 11H6M10 11H11M4 15H16C17.6569 15 19 13.6569 19 12V4C19 2.34315 17.6569 1 16 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Building = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 16.25V4.25C14.25 3.42157 13.5784 2.75 12.75 2.75H5.25C4.42157 2.75 3.75 3.42157 3.75 4.25V16.25M14.25 16.25L15.75 16.25M14.25 16.25H10.5M3.75 16.25L2.25 16.25M3.75 16.25H7.5M6.75 5.74998H7.5M6.75 8.74998H7.5M10.5 5.74998H11.25M10.5 8.74998H11.25M7.5 16.25V12.5C7.5 12.0858 7.83579 11.75 8.25 11.75H9.75C10.1642 11.75 10.5 12.0858 10.5 12.5V16.25M7.5 16.25H10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Filter = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2C1 1.44772 1.44772 1 2 1H18C18.5523 1 19 1.44772 19 2V4.58579C19 4.851 18.8946 5.10536 18.7071 5.29289L12.2929 11.7071C12.1054 11.8946 12 12.149 12 12.4142V15L8 19V12.4142C8 12.149 7.89464 11.8946 7.70711 11.7071L1.29289 5.29289C1.10536 5.10536 1 4.851 1 4.58579V2Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Night = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7903 9.4548L18.7903 5.58899"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6644 7.67798L16.9157 7.67798"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0862 1.64783L14.0862 4.22434"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4121 2.93591L12.9136 2.93591"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2245 13.4226C17.7545 13.7681 16.2238 13.7252 14.7742 13.298C13.3266 12.8718 12.0073 12.0745 10.9393 10.9804C9.87419 9.89104 9.09634 8.5393 8.67945 7.05322C8.26256 5.56714 8.22042 3.99591 8.55701 2.48834V2.48834C7.01379 2.85142 5.59284 3.63363 4.44155 4.75386C3.29025 5.87409 2.45052 7.29154 2.00945 8.85923C1.57157 10.4244 1.55009 12.0823 1.94726 13.6591C2.34444 15.2358 3.14563 16.6733 4.26685 17.8208C5.38907 18.9763 6.79018 19.8017 8.32534 20.2117C9.86049 20.6217 11.474 20.6015 12.999 20.1531C14.524 19.7047 15.9053 18.8444 16.9999 17.6612C18.0946 16.4779 18.8629 15.0146 19.2255 13.4226H19.2245Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Morning = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3077 15.9781H1.69232"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7692 20.9524H4.23077"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_581_6346)">
      <path
        d="M11 17.5097C12.11 17.5097 13.195 17.1805 14.1179 16.5639C15.0408 15.9472 15.7601 15.0708 16.1848 14.0453C16.6096 13.0198 16.7207 11.8915 16.5042 10.8028C16.2877 9.71423 15.7532 8.71427 14.9683 7.92942C14.1835 7.14457 13.1835 6.61008 12.0949 6.39354C11.0063 6.177 9.87789 6.28814 8.85243 6.71289C7.82698 7.13765 6.9505 7.85695 6.33385 8.77984C5.7172 9.70273 5.38806 10.7877 5.38806 11.8977C5.38806 13.3861 5.97932 14.8135 7.03177 15.866C8.08422 16.9184 9.51165 17.5097 11 17.5097Z"
        stroke="#111827"
        strokeWidth="2.09524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M11.5238 2.91862V1.04761"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.43854 5.4386L4.11548 4.11554"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6091 5.4386L18.9321 4.11554"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_581_6346">
        <rect
          width="15.7143"
          height="10.4762"
          fill="white"
          transform="translate(3.14288 5.2381)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Afternoon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 16.3569C12.0595 16.3569 13.0952 16.0427 13.9761 15.4541C14.8571 14.8655 15.5437 14.0289 15.9491 13.05C16.3546 12.0712 16.4607 10.9941 16.254 9.95494C16.0473 8.91581 15.5371 7.9613 14.7879 7.21213C14.0387 6.46295 13.0842 5.95276 12.0451 5.74606C11.006 5.53936 9.92887 5.64545 8.95003 6.0509C7.97118 6.45635 7.13455 7.14296 6.54593 8.02389C5.9573 8.90483 5.64313 9.94053 5.64313 11C5.64313 12.4208 6.20751 13.7833 7.21213 14.7879C8.21674 15.7925 9.57928 16.3569 11 16.3569Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.78597V1"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.19133 5.19133L3.92841 3.92841"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.78597 11H1"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.19133 16.8087L3.92841 18.0706"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 19.2141V21"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8087 16.8087L18.0716 18.0716"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2141 11H21"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8087 5.19133L18.0716 3.92841"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Evening = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4053 13.4348C14.886 13.3503 13.4516 12.7164 12.376 11.6543C11.2662 10.5592 10.6191 9.08933 10.5652 7.54162C11.2851 7.01783 12.1566 6.73648 13.0511 6.73915C13.8365 6.74351 14.6052 6.96337 15.2713 7.37415C15.9373 7.78492 16.4744 8.37041 16.8225 9.06513C17.1706 9.75986 17.3159 10.5364 17.2422 11.308C17.1686 12.0795 16.8788 12.8164 16.4053 13.4348Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9715 16.1672C15.7146 16.455 14.405 16.4195 13.1657 16.064C11.9263 15.7086 10.7978 15.0449 9.88615 14.1352C8.97448 13.2255 8.30951 12.0996 7.95368 10.8633C7.59784 9.627 7.5628 8.32078 7.85186 7.06726V7.06726C6.52906 7.37163 5.31207 8.02363 4.32723 8.95557C3.34239 9.8875 2.62561 11.0654 2.25131 12.3669C1.87702 13.6685 1.85885 15.0463 2.19869 16.3572C2.53854 17.6681 3.22401 18.8644 4.18393 19.8218C5.14386 20.7793 6.34324 21.463 7.65755 21.802C8.97186 22.1409 10.3532 22.1228 11.6581 21.7495C12.963 21.3761 14.144 20.6612 15.0783 19.6789C16.0126 18.6966 16.6663 17.4828 16.9715 16.1634V16.1672Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5451 3.64893L11.1221 1.95654"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5573 14.3982L21.0615 15.2997"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3467 8.92377L22.0434 8.50181"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0703 4.44751L17.9741 2.94716"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Print = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17H19C20.1046 17 21 16.1046 21 15V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V15C3 16.1046 3.89543 17 5 17H7M9 21H15C16.1046 21 17 20.1046 17 19V15C17 13.8954 16.1046 13 15 13H9C7.89543 13 7 13.8954 7 15V19C7 20.1046 7.89543 21 9 21ZM17 9V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V9H17Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = ({ w, h, color }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7L5 11L15 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Signer = ({ wh, color }) => (
  <svg
    width={wh}
    height={color}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1721 17.7061L17.7043 13.1738C17.8438 13.0343 18.0095 12.9236 18.1917 12.8481C18.374 12.7726 18.5693 12.7337 18.7666 12.7337C18.9639 12.7337 19.1592 12.7726 19.3415 12.8481C19.5238 12.9236 19.6894 13.0343 19.8288 13.1738L20.5583 13.9032C20.6978 14.0427 20.8085 14.2083 20.884 14.3906C20.9595 14.5728 20.9984 14.7682 20.9984 14.9655C20.9984 15.1628 20.9595 15.3581 20.884 15.5404C20.8085 15.7226 20.6978 15.8882 20.5583 16.0277L16.026 20.56C15.8865 20.6995 15.7209 20.8102 15.5386 20.8857C15.3564 20.9612 15.161 21.0001 14.9637 21.0001C14.7664 21.0001 14.5711 20.9612 14.3888 20.8857C14.2066 20.8102 14.041 20.6995 13.9015 20.56L13.1721 19.8306C13.0326 19.6911 12.9219 19.5255 12.8464 19.3432C12.7709 19.161 12.732 18.9656 12.732 18.7683C12.732 18.571 12.7709 18.3757 12.8464 18.1934C12.9219 18.0112 13.0326 17.8456 13.1721 17.7061V17.7061Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8184 13.0633L16.7122 7.53207C16.6164 7.05283 16.3855 6.61104 16.0466 6.25888C15.7077 5.90673 15.2752 5.65893 14.8 5.54481L4.38913 3.03135C4.20172 2.98616 4.00584 2.98988 3.82028 3.04214C3.63471 3.0944 3.46568 3.19345 3.3294 3.32981C3.19312 3.46617 3.09415 3.63524 3.04199 3.82084C2.98982 4.00643 2.9862 4.20233 3.03148 4.38972L5.54423 14.8005C5.65835 15.2757 5.90617 15.7083 6.25832 16.0472C6.61048 16.386 7.05227 16.617 7.53151 16.7127L13.0648 17.8197L17.8184 13.0633Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.85773 3.85861L9.81482 9.81571"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0639 11.1606C13.0641 11.537 12.9526 11.905 12.7435 12.218C12.5345 12.531 12.2373 12.775 11.8896 12.9191C11.5419 13.0632 11.1592 13.101 10.7901 13.0276C10.4209 12.9542 10.0818 12.7729 9.8156 12.5068C9.54944 12.2406 9.36816 11.9015 9.29476 11.5323C9.22136 11.1631 9.25914 10.7805 9.40325 10.4328C9.54736 10.085 9.79134 9.78785 10.1044 9.57881C10.4174 9.36978 10.7854 9.25828 11.1618 9.25842V9.25842C11.6663 9.25842 12.1501 9.45883 12.5068 9.81555C12.8636 10.1723 13.0639 10.6561 13.0639 11.1606V11.1606Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ProfilValidationIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="32" fill="#FEF2F2" />
    <path
      d="M29 23H21.5C19.8431 23 18.5 24.3431 18.5 26V39.5C18.5 41.1569 19.8431 42.5 21.5 42.5H42.5C44.1569 42.5 45.5 41.1569 45.5 39.5V26C45.5 24.3431 44.1569 23 42.5 23H35M29 23V21.5C29 19.8431 30.3431 18.5 32 18.5C33.6569 18.5 35 19.8431 35 21.5V23M29 23C29 24.6569 30.3431 26 32 26C33.6569 26 35 24.6569 35 23M27.5 35C29.1569 35 30.5 33.6569 30.5 32C30.5 30.3431 29.1569 29 27.5 29C25.8431 29 24.5 30.3431 24.5 32C24.5 33.6569 25.8431 35 27.5 35ZM27.5 35C29.4593 35 31.1261 36.2522 31.7439 38M27.5 35C25.5407 35 23.8737 36.2522 23.256 38M36.5 30.5H41M36.5 36.5H39.5"
      stroke="#EF4444"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GamepadIcon = ({ wh, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="6" x2="10" y1="11" y2="11" />
    <line x1="8" x2="8" y1="9" y2="13" />
    <line x1="15" x2="15.01" y1="12" y2="12" />
    <line x1="18" x2="18.01" y1="10" y2="10" />
    <path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z" />
  </svg>
);

const IntercomIcon = ({ wh, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-message-circle"
  >
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
  </svg>
);

const JiraIcon = ({ wh, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-square-kanban"
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M8 7v7" />
    <path d="M12 7v4" />
    <path d="M16 7v9" />
  </svg>
);

const BugIcon = ({ wh, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-bug"
  >
    <path d="m8 2 1.88 1.88" />
    <path d="M14.12 3.88 16 2" />
    <path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1" />
    <path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6" />
    <path d="M12 20v-9" />
    <path d="M6.53 9C4.6 8.8 3 7.1 3 5" />
    <path d="M6 13H2" />
    <path d="M3 21c0-2.1 1.7-3.9 3.8-4" />
    <path d="M20.97 5c0 2.1-1.6 3.8-3.5 4" />
    <path d="M22 13h-4" />
    <path d="M17.2 17c2.1.1 3.8 1.9 3.8 4" />
  </svg>
);

const TrophyIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 19.26H18V1.26H0V19.26Z" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_3578_62068" transform="scale(0.00625)" />
      </pattern>
      <image
        id="image0_3578_62068"
        width="160"
        height="160"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

const ContractDisabledIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="#F3F4F6" />
    <path
      d="M33.7583 40.5591L40.5567 33.7607C40.7659 33.5514 41.0143 33.3854 41.2877 33.2722C41.5611 33.1589 41.8541 33.1006 42.15 33.1006C42.446 33.1006 42.739 33.1589 43.0124 33.2722C43.2858 33.3854 43.5342 33.5514 43.7434 33.7607L44.8376 34.8548C45.0469 35.0641 45.2129 35.3125 45.3262 35.5859C45.4394 35.8593 45.4977 36.1523 45.4977 36.4482C45.4977 36.7442 45.4394 37.0372 45.3262 37.3106C45.2129 37.584 45.0469 37.8324 44.8376 38.0416L38.0391 44.84C37.8299 45.0493 37.5815 45.2153 37.3081 45.3286C37.0347 45.4419 36.7417 45.5002 36.4458 45.5002C36.1498 45.5002 35.8568 45.4419 35.5834 45.3286C35.31 45.2153 35.0616 45.0493 34.8524 44.84L33.7583 43.7459C33.549 43.5367 33.383 43.2883 33.2697 43.0149C33.1564 42.7415 33.0981 42.4484 33.0981 42.1525C33.0981 41.8566 33.1564 41.5636 33.2697 41.2902C33.383 41.0168 33.549 40.7684 33.7583 40.5591V40.5591Z"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.7275 33.5949L39.0682 25.2981C38.9246 24.5793 38.5782 23.9166 38.0699 23.3883C37.5616 22.8601 36.9127 22.4884 36.1999 22.3172L20.5837 18.547C20.3026 18.4792 20.0088 18.4848 19.7304 18.5632C19.4521 18.6416 19.1985 18.7902 18.9941 18.9947C18.7897 19.1992 18.6412 19.4529 18.563 19.7313C18.4847 20.0096 18.4793 20.3035 18.5472 20.5846L22.3163 36.2008C22.4875 36.9136 22.8593 37.5625 23.3875 38.0707C23.9157 38.579 24.5784 38.9254 25.2973 39.0691L33.5972 40.7295L40.7275 33.5949Z"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7866 19.7881L28.7223 28.7237"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.5958 30.7409C33.596 31.3055 33.4287 31.8575 33.1151 32.3271C32.8016 32.7966 32.3559 33.1626 31.8343 33.3788C31.3127 33.5949 30.7387 33.6515 30.1849 33.5414C29.6312 33.4313 29.1225 33.1595 28.7232 32.7602C28.324 32.361 28.0521 31.8523 27.942 31.2985C27.8319 30.7448 27.8886 30.1708 28.1047 29.6492C28.3209 29.1276 28.6869 28.6818 29.1564 28.3683C29.6259 28.0547 30.178 27.8875 30.7426 27.8877V27.8877C31.4993 27.8877 32.225 28.1883 32.7601 28.7234C33.2952 29.2585 33.5958 29.9842 33.5958 30.7409V30.7409Z"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ContractIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="#ECFDF5" />
    <path
      d="M33.7583 40.5591L40.5567 33.7607C40.7659 33.5514 41.0143 33.3854 41.2877 33.2721C41.5611 33.1588 41.8541 33.1005 42.15 33.1005C42.446 33.1005 42.739 33.1588 43.0124 33.2721C43.2858 33.3854 43.5342 33.5514 43.7434 33.7607L44.8376 34.8548C45.0469 35.064 45.2129 35.3124 45.3262 35.5858C45.4394 35.8592 45.4977 36.1522 45.4977 36.4482C45.4977 36.7441 45.4394 37.0371 45.3262 37.3105C45.2129 37.5839 45.0469 37.8323 44.8376 38.0415L38.0391 44.8399C37.8299 45.0492 37.5815 45.2153 37.3081 45.3285C37.0347 45.4418 36.7417 45.5001 36.4458 45.5001C36.1498 45.5001 35.8568 45.4418 35.5834 45.3285C35.31 45.2153 35.0616 45.0492 34.8524 44.8399L33.7583 43.7458C33.549 43.5366 33.383 43.2882 33.2697 43.0148C33.1564 42.7414 33.0981 42.4484 33.0981 42.1524C33.0981 41.8565 33.1564 41.5635 33.2697 41.2901C33.383 41.0167 33.549 40.7683 33.7583 40.5591V40.5591Z"
      stroke="#10B981"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.7275 33.5949L39.0682 25.2981C38.9246 24.5793 38.5782 23.9166 38.0699 23.3883C37.5616 22.8601 36.9127 22.4884 36.1999 22.3172L20.5837 18.547C20.3026 18.4792 20.0088 18.4848 19.7304 18.5632C19.4521 18.6416 19.1985 18.7902 18.9941 18.9947C18.7897 19.1992 18.6412 19.4529 18.563 19.7313C18.4847 20.0096 18.4793 20.3035 18.5472 20.5846L22.3163 36.2008C22.4875 36.9136 22.8593 37.5625 23.3875 38.0707C23.9157 38.579 24.5784 38.9254 25.2973 39.0691L33.5972 40.7295L40.7275 33.5949Z"
      stroke="#10B981"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7866 19.7879L28.7223 28.7236"
      stroke="#10B981"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.5958 30.7409C33.596 31.3055 33.4287 31.8575 33.1151 32.327C32.8016 32.7966 32.3559 33.1626 31.8343 33.3787C31.3127 33.5949 30.7387 33.6515 30.1849 33.5414C29.6312 33.4313 29.1225 33.1594 28.7232 32.7602C28.324 32.3609 28.0521 31.8523 27.942 31.2985C27.8319 30.7447 27.8886 30.1708 28.1047 29.6492C28.3209 29.1276 28.6869 28.6818 29.1564 28.3683C29.6259 28.0547 30.178 27.8875 30.7426 27.8877V27.8877C31.4993 27.8877 32.225 28.1883 32.7601 28.7234C33.2952 29.2584 33.5958 29.9842 33.5958 30.7409V30.7409Z"
      stroke="#10B981"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PayslipDisabledIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="#F3F4F6" />
    <path
      d="M24.5 45.5H39.5C41.1569 45.5 42.5 44.1569 42.5 42.5V28.1213C42.5 27.7235 42.342 27.342 42.0607 27.0607L33.9393 18.9393C33.658 18.658 33.2765 18.5 32.8787 18.5H24.5C22.8431 18.5 21.5 19.8431 21.5 21.5V42.5C21.5 44.1569 22.8431 45.5 24.5 45.5Z"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PayslipIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="64" height="64" rx="12" fill="#FFF6EB" />
    <path
      d="M25 45.5H40C41.6569 45.5 43 44.1569 43 42.5V28.1213C43 27.7235 42.842 27.342 42.5607 27.0607L34.4393 18.9393C34.158 18.658 33.7765 18.5 33.3787 18.5H25C23.3431 18.5 22 19.8431 22 21.5V42.5C22 44.1569 23.3431 45.5 25 45.5Z"
      stroke="#EF4444"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TimeSheetDisabledIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="#F3F4F6" />
    <path
      d="M26 24.5V18.5M38 24.5V18.5M24.5 30.5H39.5M21.5 45.5H42.5C44.1569 45.5 45.5 44.1569 45.5 42.5V24.5C45.5 22.8431 44.1569 21.5 42.5 21.5H21.5C19.8431 21.5 18.5 22.8431 18.5 24.5V42.5C18.5 44.1569 19.8431 45.5 21.5 45.5Z"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TimeSheetIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="12" fill="#EFF6FF" />
    <path
      d="M26 24.5V18.5M38 24.5V18.5M24.5 30.5H39.5M21.5 45.5H42.5C44.1569 45.5 45.5 44.1569 45.5 42.5V24.5C45.5 22.8431 44.1569 21.5 42.5 21.5H21.5C19.8431 21.5 18.5 22.8431 18.5 24.5V42.5C18.5 44.1569 19.8431 45.5 21.5 45.5Z"
      stroke="#3B82F6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchMissionIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M5 22L9.9 17.1L5 22ZM9.9 17.1C10.4 17.7 11.2 18 12 18C13.7 18 15 16.7 15 15C15 13.3 13.7 12 12 12C10.3 12 9 13.3 9 15C9 15.8 9.3 16.6 9.9 17.1Z"
        stroke="#111827"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 6H17V5C17 3.3 15.7 2 14 2H10C8.3 2 7 3.3 7 5V6H5C3.3 6 2 7.3 2 9V19C2 19.8 2.3 20.5 2.8 21C3.2 20.5 3.7 20.1 4.2 19.6C4.1 19.5 4 19.2 4 19V15.7C5 16 6 16.3 7 16.5C6.9 16.1 6.8 15.6 6.8 15.2C6.8 14.9 6.8 14.7 6.8 14.4C5.9 14.2 4.9 13.9 4 13.6V9C4 8.4 4.4 8 5 8H19C19.6 8 20 8.4 20 9V13.6C19 14 18 14.2 17 14.4C17.1 14.7 17.1 15 17.2 15.3C17.2 15.7 17.2 16 17.1 16.4C18.1 16.2 19 16 20 15.7V19C20 19.6 19.6 20 19 20H10C9.9 20.1 9.8 20.3 9.7 20.4C9.6 20.5 9.5 20.5 9.4 20.6C8.9 21 8.4 21.5 8 22.1H19C20.7 22.1 22 20.8 22 19.1V9C22 7.3 20.7 6 19 6ZM15 6H9V5C9 4.4 9.4 4 10 4H14C14.6 4 15 4.4 15 5V6Z"
        fill="#111827"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_4343">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CopyIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V8M10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SpinnerIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    className="animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

const EyeIcon = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5003 10.0003C12.5003 11.381 11.381 12.5003 10.0003 12.5003C8.61957 12.5003 7.50029 11.381 7.50029 10.0003C7.50029 8.61961 8.61957 7.50033 10.0003 7.50033C11.381 7.50033 12.5003 8.61961 12.5003 10.0003Z"
      stroke="#374151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.04883 10.0003C3.11072 6.61939 6.26929 4.16699 10.0007 4.16699C13.732 4.16699 16.8906 6.61942 17.9525 10.0004C16.8906 13.3813 13.732 15.8337 10.0007 15.8337C6.26929 15.8337 3.11071 13.3812 2.04883 10.0003Z"
      stroke="#374151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CrossIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 15L15 5M5 5L15 15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GraphIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 3.05493C6.50005 3.55238 3 7.36745 3 12C3 16.9706 7.02944 21 12 21C16.6326 21 20.4476 17.5 20.9451 13H11V3.05493Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4878 9H15V3.5123C17.5572 4.41613 19.5839 6.44285 20.4878 9Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const InformationCircle = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8333 13.3333H10V10H9.16667M10 6.66667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExternalLink = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Loading2 = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 66 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="33" cy="33.3067" r="30" stroke="#F3F4F6" strokeWidth="5" />
    <path
      d="M12.8888 55.5674C16.6783 58.991 21.279 61.3905 26.2552 62.5387C31.2314 63.6868 36.4183 63.5457 41.3247 62.1286C46.231 60.7114 50.6944 58.0653 54.2921 54.4407C57.8898 50.8161 60.5026 46.3331 61.8831 41.4163C63.2636 36.4995 63.3661 31.3117 62.1809 26.3442C60.9957 21.3767 58.5619 16.794 55.1103 13.0302C51.6586 9.26634 47.3032 6.44595 42.4566 4.83614C37.61 3.22634 32.4327 2.88041 27.4151 3.83114"
      stroke={color}
      strokeWidth="5"
    />
  </svg>
);

const Vivier = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 20H22V18C22 16.3431 20.6569 15 19 15C18.0444 15 17.1931 15.4468 16.6438 16.1429M17 20H7M17 20V18C17 17.3438 16.8736 16.717 16.6438 16.1429M7 20H2V18C2 16.3431 3.34315 15 5 15C5.95561 15 6.80686 15.4468 7.35625 16.1429M7 20V18C7 17.3438 7.12642 16.717 7.35625 16.1429M7.35625 16.1429C8.0935 14.301 9.89482 13 12 13C14.1052 13 15.9065 14.301 16.6438 16.1429M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM21 10C21 11.1046 20.1046 12 19 12C17.8954 12 17 11.1046 17 10C17 8.89543 17.8954 8 19 8C20.1046 8 21 8.89543 21 10ZM7 10C7 11.1046 6.10457 12 5 12C3.89543 12 3 11.1046 3 10C3 8.89543 3.89543 8 5 8C6.10457 8 7 8.89543 7 10Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SelfieIdentity = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.12104 17.8037C7.15267 16.6554 9.4998 16 12 16C14.5002 16 16.8473 16.6554 18.879 17.8037M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TrashIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PositiveThumb = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.3334 8.33333H4.36346C3.12449 8.33333 2.31866 9.63719 2.87275 10.7454L5.78941 16.5787C6.07173 17.1433 6.64884 17.5 7.28012 17.5H10.6282C10.7645 17.5 10.9002 17.4833 11.0325 17.4502L14.1667 16.6667M8.3334 8.33333V4.16667C8.3334 3.24619 9.07959 2.5 10.0001 2.5H10.0796C10.4959 2.5 10.8334 2.83748 10.8334 3.25377C10.8334 3.84903 11.0096 4.43096 11.3398 4.92624L14.1667 9.16667V16.6667M8.3334 8.33333H10.0001M14.1667 16.6667H15.8334C16.7539 16.6667 17.5001 15.9205 17.5001 15V10C17.5001 9.07953 16.7539 8.33333 15.8334 8.33333H13.7501"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NegativeThumb = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6667 11.6667H15.6367C16.8756 11.6667 17.6815 10.3628 17.1274 9.25464L14.2107 3.42131C13.9284 2.85667 13.3513 2.5 12.72 2.5H9.3719C9.23563 2.5 9.09988 2.51671 8.96768 2.54976L5.83339 3.33333M11.6667 11.6667V15.8333C11.6667 16.7538 10.9205 17.5 10.0001 17.5H9.9205C9.5042 17.5 9.16673 17.1625 9.16673 16.7462C9.16673 16.151 8.99053 15.569 8.66035 15.0738L5.83339 10.8333V3.33333M11.6667 11.6667H10.0001M5.83339 3.33333H4.16673C3.24625 3.33333 2.50006 4.07952 2.50006 5V10C2.50006 10.9205 3.24625 11.6667 4.16673 11.6667H6.25006"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Star = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.54894 1.42705C6.8483 0.505738 8.1517 0.50574 8.45106 1.42705L9.40837 4.37336C9.54224 4.78538 9.9262 5.06434 10.3594 5.06434H13.4574C14.4261 5.06434 14.8289 6.30395 14.0451 6.87336L11.5389 8.69427C11.1884 8.94892 11.0417 9.40028 11.1756 9.81231L12.1329 12.7586C12.4323 13.6799 11.3778 14.446 10.5941 13.8766L8.08778 12.0557C7.7373 11.8011 7.2627 11.8011 6.91221 12.0557L4.40594 13.8766C3.62222 14.446 2.56774 13.6799 2.8671 12.7586L3.82441 9.8123C3.95828 9.40028 3.81162 8.94892 3.46114 8.69427L0.954859 6.87335C0.171145 6.30395 0.573923 5.06434 1.54265 5.06434H4.64057C5.0738 5.06434 5.45776 4.78538 5.59163 4.37336L6.54894 1.42705Z"
      fill={color}
    />
  </svg>
);

const HalfStar = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.54894 0.927049C6.8483 0.00573789 8.1517 0.00574044 8.45106 0.927051L9.40837 3.87336C9.54224 4.28538 9.9262 4.56434 10.3594 4.56434H13.4574C14.4261 4.56434 14.8289 5.80395 14.0451 6.37336L11.5389 8.19427C11.1884 8.44892 11.0417 8.90028 11.1756 9.31231L12.1329 12.2586C12.4323 13.1799 11.3778 13.946 10.5941 13.3766L8.08778 11.5557C7.7373 11.3011 7.2627 11.3011 6.91221 11.5557L4.40594 13.3766C3.62222 13.946 2.56774 13.1799 2.8671 12.2586L3.82441 9.3123C3.95828 8.90028 3.81162 8.44892 3.46114 8.19427L0.954859 6.37335C0.171145 5.80395 0.573923 4.56434 1.54265 4.56434H4.64058C5.0738 4.56434 5.45776 4.28538 5.59163 3.87336L6.54894 0.927049Z"
      fill="url(#paint0_linear_575_16596)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_575_16596"
        x1="-8.5"
        y1="5"
        x2="23"
        y2="4.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.515625" stopColor="#FF9600" />
        <stop offset="0.515725" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

const Lightning = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 10V3L4 14H11L11 21L20 10L13 10Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowTopLeft = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.91674 6.24965L13.7501 6.24965M13.7501 6.24965L13.7501 12.083M13.7501 6.24965L6.25006 13.7497"
      stroke={color}
      strokeWidth="1.88563"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GroupPeople = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1666 16.6663H18.3333V14.9997C18.3333 13.619 17.214 12.4997 15.8333 12.4997C15.037 12.4997 14.3276 12.872 13.8698 13.4521M14.1666 16.6663H5.83329M14.1666 16.6663V14.9997C14.1666 14.4528 14.0613 13.9305 13.8698 13.4521M5.83329 16.6663H1.66663V14.9997C1.66663 13.619 2.78591 12.4997 4.16663 12.4997C4.96297 12.4997 5.67234 12.872 6.13016 13.4521M5.83329 16.6663V14.9997C5.83329 14.4528 5.93865 13.9305 6.13016 13.4521M6.13016 13.4521C6.74454 11.9172 8.24564 10.833 9.99996 10.833C11.7543 10.833 13.2554 11.9172 13.8698 13.4521M12.5 5.83301C12.5 7.21372 11.3807 8.33301 9.99996 8.33301C8.61925 8.33301 7.49996 7.21372 7.49996 5.83301C7.49996 4.4523 8.61925 3.33301 9.99996 3.33301C11.3807 3.33301 12.5 4.4523 12.5 5.83301ZM17.5 8.33301C17.5 9.25348 16.7538 9.99967 15.8333 9.99967C14.9128 9.99967 14.1666 9.25348 14.1666 8.33301C14.1666 7.41253 14.9128 6.66634 15.8333 6.66634C16.7538 6.66634 17.5 7.41253 17.5 8.33301ZM5.83329 8.33301C5.83329 9.25348 5.0871 9.99967 4.16663 9.99967C3.24615 9.99967 2.49996 9.25348 2.49996 8.33301C2.49996 7.41253 3.24615 6.66634 4.16663 6.66634C5.0871 6.66634 5.83329 7.41253 5.83329 8.33301Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BanIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3033 15.3033C18.2322 12.3744 18.2322 7.62563 15.3033 4.6967C12.3744 1.76777 7.62563 1.76777 4.6967 4.6967M15.3033 15.3033C12.3744 18.2322 7.62563 18.2322 4.6967 15.3033C1.76777 12.3744 1.76777 7.62563 4.6967 4.6967M15.3033 15.3033L4.6967 4.6967"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SortIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 3.33301H13.3333M2.5 6.66634H10M2.5 9.99967H10M14.1667 6.66634V16.6663M14.1667 16.6663L10.8333 13.333M14.1667 16.6663L17.5 13.333"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const KanbanIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 14.167V5.83366M7.5 14.167C7.5 15.0875 6.75381 15.8337 5.83333 15.8337H4.16667C3.24619 15.8337 2.5 15.0875 2.5 14.167V5.83366C2.5 4.91318 3.24619 4.16699 4.16667 4.16699H5.83333C6.75381 4.16699 7.5 4.91318 7.5 5.83366M7.5 14.167C7.5 15.0875 8.24619 15.8337 9.16667 15.8337H10.8333C11.7538 15.8337 12.5 15.0875 12.5 14.167M7.5 5.83366C7.5 4.91318 8.24619 4.16699 9.16667 4.16699H10.8333C11.7538 4.16699 12.5 4.91318 12.5 5.83366M12.5 14.167V5.83366M12.5 14.167C12.5 15.0875 13.2462 15.8337 14.1667 15.8337H15.8333C16.7538 15.8337 17.5 15.0875 17.5 14.167V5.83366C17.5 4.91318 16.7538 4.16699 15.8333 4.16699H14.1667C13.2462 4.16699 12.5 4.91318 12.5 5.83366"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TableIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33331 5H16.6666M3.33331 8.33333H16.6666M3.33331 11.6667H16.6666M3.33331 15H16.6666"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BellIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1400_4901)">
      <path
        d="M13 14.1667H17.1667L15.9959 12.9959C15.6784 12.6784 15.5 12.2477 15.5 11.7987V9.16667C15.5 6.98964 14.1087 5.13757 12.1667 4.45118V4.16667C12.1667 3.24619 11.4205 2.5 10.5 2.5C9.57957 2.5 8.83337 3.24619 8.83337 4.16667V4.45118C6.89139 5.13757 5.50004 6.98964 5.50004 9.16667V11.7987C5.50004 12.2477 5.32166 12.6784 5.00415 12.9959L3.83337 14.1667H8.00004M13 14.1667V15C13 16.3807 11.8808 17.5 10.5 17.5C9.11933 17.5 8.00004 16.3807 8.00004 15V14.1667M13 14.1667H8.00004"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1400_4901">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const NoteIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 5H6C4.89543 5 4 5.89543 4 7V18C4 19.1046 4.89543 20 6 20H17C18.1046 20 19 19.1046 19 18V13M17.5858 3.58579C18.3668 2.80474 19.6332 2.80474 20.4142 3.58579C21.1953 4.36683 21.1953 5.63316 20.4142 6.41421L11.8284 15H9L9 12.1716L17.5858 3.58579Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SwitchIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66663 5.83333L16.6666 5.83333M16.6666 5.83333L13.3333 2.5M16.6666 5.83333L13.3333 9.16667M13.3333 14.1667L3.33329 14.1667M3.33329 14.1667L6.66663 17.5M3.33329 14.1667L6.66663 10.8333"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArchiveIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6668 10.833V4.99967C16.6668 4.0792 15.9206 3.33301 15.0002 3.33301H5.00016C4.07969 3.33301 3.3335 4.0792 3.3335 4.99967V10.833M16.6668 10.833V14.9997C16.6668 15.9201 15.9206 16.6663 15.0002 16.6663H5.00016C4.07969 16.6663 3.3335 15.9201 3.3335 14.9997V10.833M16.6668 10.833H14.512C14.291 10.833 14.079 10.9208 13.9228 11.0771L11.9109 13.0889C11.7546 13.2452 11.5427 13.333 11.3217 13.333H8.67867C8.45766 13.333 8.2457 13.2452 8.08942 13.0889L6.07757 11.0771C5.92129 10.9208 5.70933 10.833 5.48832 10.833H3.3335"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TrainingIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 11.6663L17.5 7.49967L10 3.33301L2.5 7.49967L10 11.6663ZM10 11.6663L15.1326 8.81489C15.5848 9.95516 15.8333 11.1984 15.8333 12.4996C15.8333 13.0841 15.7832 13.6568 15.687 14.2137C13.5119 14.4252 11.5409 15.3335 10 16.7126C8.45914 15.3335 6.48809 14.4252 4.31301 14.2137C4.2168 13.6568 4.16667 13.084 4.16667 12.4996C4.16667 11.1983 4.4152 9.95514 4.8674 8.81488L10 11.6663ZM6.66667 16.6663V10.4163L10 8.56449"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LicenceIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8333 13.3337V5.00033C10.8333 4.54009 10.4602 4.16699 10 4.16699H3.33333C2.8731 4.16699 2.5 4.54009 2.5 5.00033V13.3337C2.5 13.7939 2.8731 14.167 3.33333 14.167H4.16667M10.8333 13.3337C10.8333 13.7939 10.4602 14.167 10 14.167H7.5M10.8333 13.3337L10.8333 6.66699C10.8333 6.20676 11.2064 5.83366 11.6667 5.83366H13.8215C14.0425 5.83366 14.2545 5.92146 14.4107 6.07774L17.2559 8.92291C17.4122 9.0792 17.5 9.29116 17.5 9.51217V13.3337C17.5 13.7939 17.1269 14.167 16.6667 14.167H15.8333M10.8333 13.3337C10.8333 13.7939 11.2064 14.167 11.6667 14.167H12.5M4.16667 14.167C4.16667 15.0875 4.91286 15.8337 5.83333 15.8337C6.75381 15.8337 7.5 15.0875 7.5 14.167M4.16667 14.167C4.16667 13.2465 4.91286 12.5003 5.83333 12.5003C6.75381 12.5003 7.5 13.2465 7.5 14.167M12.5 14.167C12.5 15.0875 13.2462 15.8337 14.1667 15.8337C15.0871 15.8337 15.8333 15.0875 15.8333 14.167M12.5 14.167C12.5 13.2465 13.2462 12.5003 14.1667 12.5003C15.0871 12.5003 15.8333 13.2465 15.8333 14.167"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

const ExperienceIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 11.0465C15.1839 11.984 12.6523 12.5003 10 12.5003C7.34775 12.5003 4.81608 11.984 2.5 11.0465M13.3333 5.00033V3.33366C13.3333 2.41318 12.5871 1.66699 11.6667 1.66699H8.33333C7.41286 1.66699 6.66667 2.41318 6.66667 3.33366V5.00033M10 10.0003H10.0083M4.16667 16.667H15.8333C16.7538 16.667 17.5 15.9208 17.5 15.0003V6.66699C17.5 5.74652 16.7538 5.00033 15.8333 5.00033H4.16667C3.24619 5.00033 2.5 5.74652 2.5 6.66699V15.0003C2.5 15.9208 3.24619 16.667 4.16667 16.667Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ClockIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.66667V10L12.5 12.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WarningCircle = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5.33333V8M8 10.6667H8.00667M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CommentIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3334 5.33341H12.6667C13.4031 5.33341 14.0001 5.93037 14.0001 6.66675V10.6667C14.0001 11.4031 13.4031 12.0001 12.6667 12.0001H11.3334V14.6667L8.66673 12.0001H6.00006C5.63187 12.0001 5.29854 11.8508 5.05725 11.6096M5.05725 11.6096L7.3334 9.33341H10.0001C10.7364 9.33341 11.3334 8.73646 11.3334 8.00008V4.00008C11.3334 3.2637 10.7364 2.66675 10.0001 2.66675H3.33339C2.59701 2.66675 2.00006 3.2637 2.00006 4.00008V8.00008C2.00006 8.73646 2.59701 9.33341 3.33339 9.33341H4.66673V12.0001L5.05725 11.6096Z"
      stroke={color}
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferenceIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L12 17.5L5 21V5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PersonIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8346 5.83333C13.8346 7.67428 12.3423 9.16667 10.5013 9.16667C8.66035 9.16667 7.16797 7.67428 7.16797 5.83333C7.16797 3.99238 8.66035 2.5 10.5013 2.5C12.3423 2.5 13.8346 3.99238 13.8346 5.83333Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5013 11.667C7.27964 11.667 4.66797 14.2787 4.66797 17.5003H16.3346C16.3346 14.2787 13.723 11.667 10.5013 11.667Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Lucide inbox (viviers / liste) */
const InboxIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline
      points="22 12 16 12 14 15 10 15 8 12 2 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Lucide star outline (avis) — distinct de Star (plein 15×15) */
const StarOutline = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AddMission = ({ wh, cIcon }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cIcon}
  >
    <g clipPath="url(#clip0_10_4370)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 6H19C20.7 6 22 7.3 22 9V19.1C22 20.8 20.7 22.1 19 22.1H15.5371C15.7814 21.4389 15.9353 20.7338 15.9836 20H19C19.6 20 20 19.6 20 19V15.7C19 16 18.1 16.2 17.1 16.4C17.2 16 17.2 15.7 17.2 15.3V15.3C17.15 15.15 17.125 15 17.1 14.85C17.075 14.7 17.05 14.55 17 14.4C18 14.2 19 14 20 13.6V9C20 8.4 19.6 8 19 8H5C4.4 8 4 8.4 4 9V13.4995C3.19073 14.1073 2.50843 14.8751 2 15.7558V9C2 7.3 3.3 6 5 6H7V5C7 3.3 8.3 2 10 2H14C15.7 2 17 3.3 17 5V6ZM9 6H15V5C15 4.4 14.6 4 14 4H10C9.4 4 9 4.4 9 5V6Z"
      />
    </g>
    <path
      d="M9.5 14V17.5M9.5 17.5V21M9.5 17.5H13M9.5 17.5L6 17.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_10_4370">
        <rect width="20" height="21" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

const InformationIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8333 13.3333H10V10H9.16667M10 6.66667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EmptyStateScheduleMissingPeriods = ({ wh }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="256" height="256" rx="128" fill="#EFF0F5" />
    <path
      d="M40.5453 186.114L62.5371 75.2872C62.7615 74.1563 63.7538 73.3416 64.9067 73.3416H192.55C194.073 73.3416 195.216 74.7337 194.92 76.2276L172.928 187.054C172.704 188.185 171.711 189 170.558 189H42.915C41.392 189 40.2489 187.608 40.5453 186.114Z"
      fill="#B1BABF"
    />
    <path
      d="M48.1804 186.271L62.6487 75.4447C62.8057 74.2416 63.8308 73.3416 65.0442 73.3416H192.741C194.199 73.3416 195.325 74.624 195.136 76.0702L180.668 186.897C180.511 188.1 179.486 189 178.273 189H50.5759C49.1175 189 47.9916 187.718 48.1804 186.271Z"
      fill="#C0C9CD"
    />
    <path
      d="M55.8366 186.433L62.7814 75.6063C62.8612 74.3333 63.9169 73.3416 65.1925 73.3416H192.921C194.314 73.3416 195.419 74.5176 195.332 75.9085L188.387 186.735C188.307 188.008 187.251 189 185.976 189H58.2477C56.8541 189 55.7495 187.824 55.8366 186.433Z"
      fill="#C0C9CD"
    />
    <path
      d="M65.8815 186.647L62.9879 75.8205C62.9524 74.462 64.044 73.3416 65.4029 73.3416H193.139C194.449 73.3416 195.52 74.3851 195.554 75.6944L198.448 186.521C198.483 187.88 197.391 189 196.033 189H68.2966C66.9869 189 65.9157 187.956 65.8815 186.647Z"
      fill="#D3D9DD"
    />
    <path
      d="M83.1041 187.006L63.4272 76.1797C63.1645 74.6997 64.3027 73.3416 65.8059 73.3416H193.468C194.639 73.3416 195.642 74.1818 195.847 75.3351L215.523 186.162C215.786 187.642 214.648 189 213.145 189H85.4827C84.3114 189 83.3088 188.16 83.1041 187.006Z"
      fill="#E9EAEF"
    />
    <path
      d="M147.108 108.515C146.829 107.028 147.97 105.653 149.483 105.653H154.23C155.393 105.653 156.39 106.481 156.605 107.624L157.511 112.456C157.789 113.943 156.649 115.317 155.136 115.317H150.389C149.226 115.317 148.228 114.489 148.014 113.346L147.108 108.515Z"
      fill="#D3D9DD"
    />
    <path
      d="M164.321 108.515C164.042 107.028 165.183 105.653 166.696 105.653H171.443C172.606 105.653 173.603 106.481 173.818 107.624L174.723 112.456C175.002 113.943 173.862 115.317 172.349 115.317H167.602C166.439 115.317 165.441 114.489 165.227 113.346L164.321 108.515Z"
      fill="#D3D9DD"
    />
    <path
      d="M181.534 108.515C181.255 107.028 182.396 105.653 183.908 105.653H188.656C189.818 105.653 190.816 106.481 191.03 107.624L191.936 112.456C192.215 113.943 191.075 115.317 189.562 115.317H184.814C183.652 115.317 182.654 114.489 182.44 113.346L181.534 108.515Z"
      fill="#D3D9DD"
    />
    <path
      d="M80.6727 124.217C80.3939 122.731 81.5345 121.356 83.0471 121.356H87.7946C88.9572 121.356 89.9548 122.184 90.1691 123.327L91.075 128.159C91.3538 129.645 90.2132 131.02 88.7006 131.02H83.9531C82.7905 131.02 81.7929 130.192 81.5786 129.049L80.6727 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M97.8856 124.217C97.6068 122.731 98.7474 121.356 100.26 121.356H105.008C106.17 121.356 107.168 122.184 107.382 123.327L108.288 128.159C108.567 129.645 107.426 131.02 105.913 131.02H101.166C100.003 131.02 99.0058 130.192 98.7915 129.049L97.8856 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M115.098 124.217C114.819 122.731 115.96 121.356 117.473 121.356H122.22C123.383 121.356 124.38 122.184 124.595 123.327L125.501 128.159C125.779 129.645 124.639 131.02 123.126 131.02H118.379C117.216 131.02 116.218 130.192 116.004 129.049L115.098 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M132.311 124.217C132.032 122.731 133.173 121.356 134.686 121.356H139.433C140.596 121.356 141.593 122.184 141.808 123.327L142.713 128.159C142.992 129.645 141.852 131.02 140.339 131.02H135.592C134.429 131.02 133.431 130.192 133.217 129.049L132.311 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M149.524 124.217C149.245 122.731 150.386 121.356 151.898 121.356H156.646C157.808 121.356 158.806 122.184 159.02 123.327L159.926 128.159C160.205 129.645 159.065 131.02 157.552 131.02H152.804C151.642 131.02 150.644 130.192 150.43 129.049L149.524 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M166.737 124.217C166.458 122.731 167.599 121.356 169.111 121.356H173.859C175.021 121.356 176.019 122.184 176.233 123.327L177.139 128.159C177.418 129.645 176.277 131.02 174.765 131.02H170.017C168.855 131.02 167.857 130.192 167.643 129.049L166.737 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M183.95 124.217C183.671 122.731 184.812 121.356 186.324 121.356H191.072C192.234 121.356 193.232 122.184 193.446 123.327L194.352 128.159C194.631 129.645 193.49 131.02 191.978 131.02H187.23C186.068 131.02 185.07 130.192 184.856 129.049L183.95 124.217Z"
      fill="#D3D9DD"
    />
    <path
      d="M84.2965 139.92C84.0177 138.434 85.1583 137.059 86.6709 137.059H91.4184C92.5809 137.059 93.5786 137.887 93.7929 139.03L94.6988 143.862C94.9776 145.348 93.837 146.723 92.3243 146.723H87.5769C86.4143 146.723 85.4166 145.895 85.2024 144.752L84.2965 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M101.509 139.92C101.23 138.434 102.371 137.059 103.884 137.059H108.631C109.794 137.059 110.791 137.887 111.006 139.03L111.911 143.862C112.19 145.348 111.05 146.723 109.537 146.723H104.79C103.627 146.723 102.629 145.895 102.415 144.752L101.509 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M118.722 139.92C118.443 138.434 119.584 137.059 121.096 137.059H125.844C127.006 137.059 128.004 137.887 128.218 139.03L129.124 143.862C129.403 145.348 128.263 146.723 126.75 146.723H122.002C120.84 146.723 119.842 145.895 119.628 144.752L118.722 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M135.935 139.92C135.656 138.434 136.797 137.059 138.309 137.059H143.057C144.219 137.059 145.217 137.887 145.431 139.03L146.337 143.862C146.616 145.348 145.475 146.723 143.963 146.723H139.215C138.053 146.723 137.055 145.895 136.841 144.752L135.935 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M153.148 139.92C152.869 138.434 154.01 137.059 155.522 137.059H160.27C161.432 137.059 162.43 137.887 162.644 139.03L163.55 143.862C163.829 145.348 162.688 146.723 161.176 146.723H156.428C155.266 146.723 154.268 145.895 154.054 144.752L153.148 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M170.361 139.92C170.082 138.434 171.222 137.059 172.735 137.059H177.483C178.645 137.059 179.643 137.887 179.857 139.03L180.763 143.862C181.042 145.348 179.901 146.723 178.389 146.723H173.641C172.479 146.723 171.481 145.895 171.267 144.752L170.361 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M187.574 139.92C187.295 138.434 188.435 137.059 189.948 137.059H194.696C195.858 137.059 196.856 137.887 197.07 139.03L197.976 143.862C198.255 145.348 197.114 146.723 195.601 146.723H190.854C189.691 146.723 188.694 145.895 188.479 144.752L187.574 139.92Z"
      fill="#D3D9DD"
    />
    <path
      d="M87.3162 155.623C87.0375 154.137 88.178 152.762 89.6907 152.762H94.4382C95.6007 152.762 96.5984 153.59 96.8126 154.733L97.7186 159.565C97.9973 161.051 96.8568 162.426 95.3441 162.426H90.5966C89.4341 162.426 88.4364 161.598 88.2222 160.455L87.3162 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M104.529 155.623C104.25 154.137 105.391 152.762 106.904 152.762H111.651C112.814 152.762 113.811 153.59 114.026 154.733L114.931 159.565C115.21 161.051 114.07 162.426 112.557 162.426H107.81C106.647 162.426 105.649 161.598 105.435 160.455L104.529 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M121.742 155.623C121.463 154.137 122.604 152.762 124.116 152.762H128.864C130.027 152.762 131.024 153.59 131.238 154.733L132.144 159.565C132.423 161.051 131.283 162.426 129.77 162.426H125.022C123.86 162.426 122.862 161.598 122.648 160.455L121.742 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M138.955 155.623C138.676 154.137 139.816 152.762 141.329 152.762H146.077C147.239 152.762 148.237 153.59 148.451 154.733L149.357 159.565C149.636 161.051 148.495 162.426 146.983 162.426H142.235C141.073 162.426 140.075 161.598 139.861 160.455L138.955 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M156.168 155.623C155.889 154.137 157.029 152.762 158.542 152.762H163.289C164.452 152.762 165.45 153.59 165.664 154.733L166.57 159.565C166.849 161.051 165.708 162.426 164.195 162.426H159.448C158.285 162.426 157.288 161.598 157.073 160.455L156.168 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M173.38 155.623C173.102 154.137 174.242 152.762 175.755 152.762H180.502C181.665 152.762 182.663 153.59 182.877 154.733L183.783 159.565C184.062 161.051 182.921 162.426 181.408 162.426H176.661C175.498 162.426 174.501 161.598 174.286 160.455L173.38 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M190.593 155.623C190.315 154.137 191.455 152.762 192.968 152.762H197.715C198.878 152.762 199.876 153.59 200.09 154.733L200.996 159.565C201.274 161.051 200.134 162.426 198.621 162.426H193.874C192.711 162.426 191.714 161.598 191.499 160.455L190.593 155.623Z"
      fill="#D3D9DD"
    />
    <path
      d="M89.732 171.326C89.4532 169.84 90.5938 168.465 92.1065 168.465H96.854C98.0165 168.465 99.0142 169.293 99.2284 170.436L100.134 175.268C100.413 176.754 99.2725 178.129 97.7599 178.129H93.0124C91.8499 178.129 90.8522 177.301 90.6379 176.158L89.732 171.326Z"
      fill="#D3D9DD"
    />
    <path
      d="M106.945 171.326C106.666 169.84 107.807 168.465 109.319 168.465H114.067C115.229 168.465 116.227 169.293 116.441 170.436L117.347 175.268C117.626 176.754 116.485 178.129 114.973 178.129H110.225C109.063 178.129 108.065 177.301 107.851 176.158L106.945 171.326Z"
      fill="#D3D9DD"
    />
    <path
      d="M124.158 171.326C123.879 169.84 125.02 168.465 126.532 168.465H131.28C132.442 168.465 133.44 169.293 133.654 170.436L134.56 175.268C134.839 176.754 133.698 178.129 132.186 178.129H127.438C126.276 178.129 125.278 177.301 125.064 176.158L124.158 171.326Z"
      fill="#D3D9DD"
    />
    <path
      d="M141.371 171.326C141.092 169.84 142.232 168.465 143.745 168.465H148.493C149.655 168.465 150.653 169.293 150.867 170.436L151.773 175.268C152.052 176.754 150.911 178.129 149.399 178.129H144.651C143.489 178.129 142.491 177.301 142.277 176.158L141.371 171.326Z"
      fill="#D3D9DD"
    />
    <path
      d="M158.584 171.326C158.305 169.84 159.445 168.465 160.958 168.465H165.706C166.868 168.465 167.866 169.293 168.08 170.436L168.986 175.268C169.265 176.754 168.124 178.129 166.611 178.129H161.864C160.701 178.129 159.704 177.301 159.49 176.158L158.584 171.326Z"
      fill="#D3D9DD"
    />
    <path
      d="M175.796 171.326C175.518 169.84 176.658 168.465 178.171 168.465H182.918C184.081 168.465 185.079 169.293 185.293 170.436L186.199 175.268C186.478 176.754 185.337 178.129 183.824 178.129H179.077C177.914 178.129 176.917 177.301 176.702 176.158L175.796 171.326Z"
      fill="#D3D9DD"
    />
    <path
      d="M193.009 171.326C192.73 169.84 193.871 168.465 195.384 168.465H200.131C201.294 168.465 202.291 169.293 202.506 170.436L203.411 175.268C203.69 176.754 202.55 178.129 201.037 178.129H196.29C195.127 178.129 194.129 177.301 193.915 176.158L193.009 171.326Z"
      fill="#D3D9DD"
    />
    <mask
      id="mask0_3046_12288"
      maskUnits="userSpaceOnUse"
      x="63"
      y="73"
      width="153"
      height="116"
    >
      <path
        d="M82.802 186.704L63.1252 75.8778C62.8625 74.3977 64.0007 73.0396 65.5039 73.0396H193.166C194.337 73.0396 195.34 73.8799 195.545 75.0331L215.221 185.86C215.484 187.34 214.346 188.698 212.843 188.698H85.1807C84.0094 188.698 83.0068 187.858 82.802 186.704Z"
        fill="#D7E9FF"
      />
    </mask>
    <g mask="url(#mask0_3046_12288)">
      <rect
        x="46.3145"
        y="34.9901"
        width="166.693"
        height="60.396"
        fill="#B1BABF"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.8448 85.0354C81.4127 84.9577 81.9748 84.826 82.5233 84.6403C84.3214 84.0315 85.8828 82.8732 86.9871 81.329C88.0913 79.7849 88.6825 77.9328 88.6773 76.0345C88.6721 74.1361 88.0707 72.2874 86.9579 70.7493C85.8452 69.2112 84.2775 68.0616 82.476 67.4627C80.6746 66.8638 78.7306 66.8459 76.9184 67.4115C75.1063 67.9772 73.5177 69.0978 72.3769 70.6152C71.8192 71.3569 71.3823 72.1752 71.0767 73.0396H73.0295C73.2449 72.5697 73.511 72.1217 73.8251 71.704C74.7377 70.4902 76.0086 69.5937 77.4583 69.1411C78.9081 68.6886 80.4633 68.7029 81.9044 69.182C83.3456 69.6611 84.5998 70.5809 85.4899 71.8113C86.3801 73.0418 86.8613 74.5208 86.8654 76.0395C86.8696 77.5582 86.3966 79.0398 85.5132 80.2751C84.6298 81.5105 83.3807 82.4371 81.9422 82.9241C81.3281 83.132 80.6928 83.2554 80.0532 83.2938L80.8448 85.0354Z"
      fill="#C9CFD4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.297 85.0354C106.865 84.9577 107.427 84.826 107.975 84.6403C109.774 84.0315 111.335 82.8732 112.439 81.329C113.543 79.7849 114.135 77.9328 114.129 76.0345C114.124 74.1361 113.523 72.2874 112.41 70.7493C111.297 69.2112 109.73 68.0616 107.928 67.4627C106.127 66.8638 104.183 66.8459 102.371 67.4115C100.558 67.9772 98.9698 69.0978 97.829 70.6152C97.2713 71.3569 96.8344 72.1752 96.5288 73.0396H98.4817C98.697 72.5697 98.9632 72.1217 99.2772 71.704C100.19 70.4902 101.461 69.5937 102.91 69.1411C104.36 68.6886 105.915 68.7029 107.357 69.182C108.798 69.6611 110.052 70.5809 110.942 71.8113C111.832 73.0418 112.313 74.5208 112.318 76.0395C112.322 77.5582 111.849 79.0398 110.965 80.2751C110.082 81.5105 108.833 82.4371 107.394 82.9241C106.78 83.132 106.145 83.2554 105.505 83.2938L106.297 85.0354Z"
      fill="#C9CFD4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.749 85.0354C132.317 84.9577 132.879 84.826 133.428 84.6403C135.226 84.0315 136.787 82.8732 137.891 81.329C138.996 79.7849 139.587 77.9328 139.582 76.0345C139.576 74.1361 138.975 72.2874 137.862 70.7493C136.75 69.2112 135.182 68.0616 133.38 67.4627C131.579 66.8638 129.635 66.8459 127.823 67.4115C126.011 67.9772 124.422 69.0978 123.281 70.6152C122.723 71.3569 122.287 72.1752 121.981 73.0396H123.934C124.149 72.5697 124.415 72.1217 124.729 71.704C125.642 70.4902 126.913 69.5937 128.363 69.1411C129.812 68.6886 131.368 68.7029 132.809 69.182C134.25 69.6611 135.504 70.5809 136.394 71.8113C137.284 73.0418 137.766 74.5208 137.77 76.0395C137.774 77.5582 137.301 79.0398 136.418 80.2751C135.534 81.5105 134.285 82.4371 132.847 82.9241C132.232 83.132 131.597 83.2554 130.958 83.2938L131.749 85.0354Z"
      fill="#C9CFD4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M157.202 85.0354C157.769 84.9577 158.331 84.826 158.88 84.6403C160.678 84.0315 162.24 82.8732 163.344 81.329C164.448 79.7849 165.039 77.9328 165.034 76.0345C165.029 74.1361 164.427 72.2874 163.315 70.7493C162.202 69.2112 160.634 68.0616 158.833 67.4627C157.031 66.8638 155.087 66.8459 153.275 67.4115C151.463 67.9772 149.874 69.0978 148.734 70.6152C148.176 71.3569 147.739 72.1752 147.433 73.0396H149.386C149.602 72.5697 149.868 72.1217 150.182 71.704C151.094 70.4902 152.365 69.5937 153.815 69.1411C155.265 68.6886 156.82 68.7029 158.261 69.182C159.702 69.6611 160.956 70.5809 161.847 71.8113C162.737 73.0418 163.218 74.5208 163.222 76.0395C163.226 77.5582 162.753 79.0398 161.87 80.2751C160.987 81.5105 159.737 82.4371 158.299 82.9241C157.685 83.132 157.049 83.2554 156.41 83.2938L157.202 85.0354Z"
      fill="#C9CFD4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M182.654 85.0354C183.222 84.9577 183.784 84.826 184.332 84.6403C186.13 84.0315 187.692 82.8732 188.796 81.329C189.9 79.7849 190.491 77.9328 190.486 76.0345C190.481 74.1361 189.879 72.2874 188.767 70.7493C187.654 69.2112 186.086 68.0616 184.285 67.4627C182.483 66.8638 180.539 66.8459 178.727 67.4115C176.915 67.9772 175.327 69.0978 174.186 70.6152C173.628 71.3569 173.191 72.1752 172.885 73.0396H174.838C175.054 72.5697 175.32 72.1217 175.634 71.704C176.547 70.4902 177.817 69.5937 179.267 69.1411C180.717 68.6886 182.272 68.7029 183.713 69.182C185.154 69.6611 186.409 70.5809 187.299 71.8113C188.189 73.0418 188.67 74.5208 188.674 76.0395C188.678 77.5582 188.205 79.0398 187.322 80.2751C186.439 81.5105 185.19 82.4371 183.751 82.9241C183.137 83.132 182.502 83.2554 181.862 83.2938L182.654 85.0354Z"
      fill="#C9CFD4"
    />
  </svg>
);

const QuestionMarkIcon = ({ wh, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.575 7.5C7.77 6.94 8.155 6.47 8.665 6.17C9.175 5.87 9.775 5.76 10.355 5.86C10.94 5.96 11.465 6.26 11.84 6.71C12.215 7.16 12.415 7.72 12.415 8.3C12.415 10 9.915 10.85 9.915 10.85M10 14.17H10.008M17.5 10C17.5 14.14 14.14 17.5 10 17.5C5.86 17.5 2.5 14.14 2.5 10C2.5 5.86 5.86 2.5 10 2.5C14.14 2.5 17.5 5.86 17.5 10Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SaveIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2.5C13.1063 2.50626 13.5256 2.68598 13.8333 3L17 6.16667C17.314 6.47438 17.4937 6.89372 17.5 7.33333V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H12.6667Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 17.5V11.6667C14.1667 11.4457 14.0789 11.2337 13.9226 11.0774C13.7663 10.9211 13.5544 10.8333 13.3334 10.8333H6.66671C6.44569 10.8333 6.23373 10.9211 6.07745 11.0774C5.92117 11.2337 5.83337 11.4457 5.83337 11.6667V17.5"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83337 2.5V5.83333C5.83337 6.05435 5.92117 6.26631 6.07745 6.42259C6.23373 6.57887 6.44569 6.66667 6.66671 6.66667H12.5"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CogIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.60386 3.59782C8.95919 2.13414 11.0408 2.13414 11.3961 3.59782C11.6257 4.54334 12.709 4.99204 13.5398 4.48577C14.8261 3.70205 16.298 5.17398 15.5143 6.46021C15.008 7.29111 15.4567 8.37437 16.4022 8.60392C17.8659 8.95925 17.8659 11.0409 16.4022 11.3962C15.4567 11.6257 15.008 12.709 15.5143 13.5399C16.298 14.8261 14.8261 16.2981 13.5398 15.5144C12.709 15.0081 11.6257 15.4568 11.3961 16.4023C11.0408 17.866 8.95919 17.866 8.60386 16.4023C8.37431 15.4568 7.29105 15.0081 6.46016 15.5144C5.17392 16.2981 3.70199 14.8261 4.48571 13.5399C4.99198 12.709 4.54327 11.6257 3.59776 11.3962C2.13408 11.0409 2.13408 8.95925 3.59776 8.60392C4.54327 8.37437 4.99198 7.29111 4.48571 6.46021C3.70199 5.17398 5.17392 3.70205 6.46015 4.48577C7.29105 4.99204 8.37431 4.54334 8.60386 3.59782Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 10.0001C12.5 11.3808 11.3807 12.5001 10 12.5001C8.61929 12.5001 7.5 11.3808 7.5 10.0001C7.5 8.61935 8.61929 7.50006 10 7.50006C11.3807 7.50006 12.5 8.61935 12.5 10.0001Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DragIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16671 12.5C3.70647 12.5 3.33337 12.1269 3.33337 11.6667C3.33337 11.2064 3.70647 10.8333 4.16671 10.8333H15.8334C16.2936 10.8333 16.6667 11.2064 16.6667 11.6667C16.6667 12.1269 16.2936 12.5 15.8334 12.5H4.16671ZM4.16671 9.16667C3.70647 9.16667 3.33337 8.79357 3.33337 8.33333C3.33337 7.8731 3.70647 7.5 4.16671 7.5H15.8334C16.2936 7.5 16.6667 7.8731 16.6667 8.33333C16.6667 8.79357 16.2936 9.16667 15.8334 9.16667H4.16671Z"
      fill={color}
    />
  </svg>
);

const PadLockIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99992 12.5V14.1667M4.99992 17.5H14.9999C15.9204 17.5 16.6666 16.7538 16.6666 15.8333V10.8333C16.6666 9.91286 15.9204 9.16667 14.9999 9.16667H4.99992C4.07944 9.16667 3.33325 9.91286 3.33325 10.8333V15.8333C3.33325 16.7538 4.07944 17.5 4.99992 17.5ZM13.3333 9.16667V5.83333C13.3333 3.99238 11.8409 2.5 9.99992 2.5C8.15897 2.5 6.66659 3.99238 6.66659 5.83333V9.16667H13.3333Z"
      stroke={color}
      strokeWidth="1.66667"
      stroke-linecap="round"
    />
  </svg>
);

const RefreshIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3v5h5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16h5v5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RotateFadingClock = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C14.516 3.00947 16.931 3.99122 18.74 5.74"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7402 5.73999L21.0002 7.99999"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 8V3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 19.7941C1.5 16.3301 1.5 7.67005 7.5 4.20605"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 4.206C8.86815 3.416 10.4201 3.00007 12 3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7V12L16 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 20.7749C13.3438 20.9244 12.673 20.9999 12 20.9999"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 17.656C18.5583 18.198 18.0549 18.6866 17.5 19.112"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12C20.999 12.6731 20.9225 13.344 20.772 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 8H16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SendIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m21.854 2.147-10.94 10.939"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReceiptEuroIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.828 14.829a4 4 0 0 1-5.656 0 4 4 0 0 1 0-5.657 4 4 0 0 1 5.656 0" />
    <path d="M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z" />
    <path d="M8 12h5" />
  </svg>
);

const WalletIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
  </svg>
);

const SparklesIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 3V7M3 5H7M6 17V21M4 19H8M13 3L15.2857 9.85714L21 12L15.2857 14.1429L13 21L10.7143 14.1429L5 12L10.7143 9.85714L13 3Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Lucide "forklift": licences and CACES in the document type picker.
const Forklift = ({ wh = 24, color = 'currentColor' }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12H5a2 2 0 0 0-2 2v5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="13" cy="19" r="2" stroke={color} strokeWidth="2" />
    <circle cx="5" cy="19" r="2" stroke={color} strokeWidth="2" />
    <path
      d="M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Lucide "handshake" and "user-search" (ISC): the Commercial and Recrutement
// groups of the sidebar.
const HandshakeIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m11 17 2 2a1 1 0 1 0 3-3" />
    <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
    <path d="m21 3 1 11h-2" />
    <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
    <path d="M3 4h8" />
  </svg>
);

const UserSearchIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="7" r="4" />
    <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
    <circle cx="17" cy="17" r="3" />
    <path d="m21 21-1.9-1.9" />
  </svg>
);

// Lucide "receipt" (ISC): the Paie et facturation group of the sidebar.
const ReceiptIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 17V7" />
    <path d="M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
    <path d="M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z" />
  </svg>
);

// Lucide "phone-call", "map-pin", "clipboard-list", "calendar-days" and
// "calendar-clock" (ISC): the task types and the planning of the home page.
const PhoneCallIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 2a9 9 0 0 1 9 9" />
    <path d="M13 6a5 5 0 0 1 5 5" />
    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
  </svg>
);

const MapPinIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ClipboardListIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <path d="M12 11h4" />
    <path d="M12 16h4" />
    <path d="M8 11h.01" />
    <path d="M8 16h.01" />
  </svg>
);

const CalendarDaysIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 2v3" />
    <path d="M16 2v3" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18" />
    <path d="M8 13h.01" />
    <path d="M12 13h.01" />
    <path d="M16 13h.01" />
    <path d="M8 17h.01" />
    <path d="M12 17h.01" />
    <path d="M16 17h.01" />
  </svg>
);

// lucide `layout-dashboard`, the home of the prototype's sidebar.
const LayoutDashboardIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="7" height="9" x="3" y="3" rx="1" />
    <rect width="7" height="5" x="14" y="3" rx="1" />
    <rect width="7" height="9" x="14" y="12" rx="1" />
    <rect width="7" height="5" x="3" y="16" rx="1" />
  </svg>
);

const CalendarClockIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 14v2.2l1.6 1" />
    <path d="M16 2v3" />
    <path d="M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338" />
    <path d="M3 9h5.859" />
    <path d="M8 2v3" />
    <circle cx="16" cy="16" r="6" />
  </svg>
);

// lucide icons of the statistics page (flame, target, trending-up,
// circle-check, trophy, chart-column), drawn like CalendarClockIcon.
const lucideIcon = (paths) => {
  const Icon = ({ wh, color }) => (
    <svg
      width={wh}
      height={wh}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
  return Icon;
};

const FlameIcon = lucideIcon(
  <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />,
);
const TargetIcon = lucideIcon(
  <>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </>,
);
const TrendingUpIcon = lucideIcon(
  <>
    <path d="M16 7h6v6" />
    <path d="m22 7-8.5 8.5-5-5L2 17" />
  </>,
);
const CircleCheckIcon = lucideIcon(
  <>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </>,
);
const TrophyLineIcon = lucideIcon(
  <>
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </>,
);
const ChartColumnIcon = lucideIcon(
  <>
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path d="M18 17V9" />
    <path d="M13 17V5" />
    <path d="M8 17v-3" />
  </>,
);

// lucide « list »: the list view.
const ListIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 6h.01M3 12h.01M3 18h.01M8 6h13M8 12h13M8 18h13"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// lucide « columns-3 »: the kanban view.
const Columns3Icon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2" />
    <path d="M9 3v18M15 3v18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// lucide « building-2 »: a company, as on the prototype.
const Building2Icon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 12h4M10 8h4M14 21v-3a2 2 0 0 0-4 0v3M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// lucide « network »: a group of companies, as on the prototype.
const NetworkIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="16" y="16" width="6" height="6" rx="1" />
      <rect x="2" y="16" width="6" height="6" rx="1" />
      <rect x="9" y="2" width="6" height="6" rx="1" />
      <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3M12 12V8" />
    </g>
  </svg>
);

// lucide « car », as on the prototype's planning.
const CarIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2M9 17h6" />
      <circle cx="7" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
    </g>
  </svg>
);

// lucide « house », as on the prototype's planning.
const HouseIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
      <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </g>
  </svg>
);

// lucide « calendar-plus », as on the prototype's planning.
const CalendarPlusIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 18h6M16 2v3M19 15v6M21 11.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.3M3 9h18M8 2v3" />
    </g>
  </svg>
);

// lucide « video », as on the prototype's planning.
const VideoIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
      <rect x="2" y="6" width="14" height="12" rx="2" />
    </g>
  </svg>
);

// lucide « grip-vertical », as on the prototype's planning.
const GripVerticalIcon = ({ wh, color }) => (
  <svg width={wh} height={wh} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="5" r="1" />
      <circle cx="9" cy="12" r="1" />
      <circle cx="9" cy="19" r="1" />
      <circle cx="15" cy="5" r="1" />
      <circle cx="15" cy="12" r="1" />
      <circle cx="15" cy="19" r="1" />
    </g>
  </svg>
);

const History = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 7v5l4 2" />
  </svg>
);

export {
  CarIcon,
  HouseIcon,
  CalendarPlusIcon,
  VideoIcon,
  GripVerticalIcon,
  NetworkIcon,
  Building2Icon,
  ListIcon,
  Columns3Icon,
  Add,
  AddMission,
  AddVivier,
  Afternoon,
  ArchiveIcon,
  ArrowLeft,
  ArrowRight,
  ArrowTopLeft,
  BanIcon,
  BankIcon,
  Bars,
  BellIcon,
  Building,
  Cadenas,
  Calendar,
  Camion,
  CardBank,
  CardIdentity,
  CardMeeting,
  CardProofAddress,
  CardVitale,
  Check,
  CheckIcon,
  ChevronDown,
  ChevronLeft,
  ChevronLeftNav,
  ChevronRight,
  ChevronRightNav,
  ChevronTop,
  ClockIcon,
  Close,
  CloseModal,
  CommentIcon,
  ContractDisabledIcon,
  ContractIcon,
  CopyIcon,
  CreditCard,
  CrossIcon,
  DashboardIcon,
  Delete,
  DocumentIcon,
  Dots,
  DotsV,
  Drapeau,
  EmptyStateComingSoon,
  EmptyStateContract,
  EmptyStateMission,
  EmptyStateMissionSearch,
  EmptyStatePayslip,
  EmptyStateScheduleMissingPeriods,
  EmptyStateTimeRecord,
  Euro,
  Evening,
  Exclamation,
  ExperienceIcon,
  ExternalLink,
  EyeIcon,
  Facebook,
  Filter,
  GraphIcon,
  GroupPeople,
  HalfStar,
  Help,
  HelpIcon,
  HomeSvg,
  Import,
  Information,
  InboxIcon,
  InformationCircle,
  InformationIcon,
  Instagram,
  Interrogation,
  InterrogationCercle,
  JobbizLogo,
  JustifyIcon,
  KanbanIcon,
  LetterMail,
  LicenceIcon,
  Lightning,
  Linkedin,
  LinkIcon,
  Loading,
  Loading2,
  Localisation,
  Logout,
  Mail,
  MenuBar,
  Metier,
  MissionIcon,
  Modify,
  Morning,
  NegativeThumb,
  Night,
  NoShowPassword,
  NoteIcon,
  PayslipDisabledIcon,
  PayslipIcon,
  Pencil,
  PersonIcon,
  PhoneIcon,
  Plus,
  PositiveThumb,
  Print,
  ProfileDefault,
  ProfilIcon,
  ProfilValidationIcon,
  ReferenceIcon,
  RefreshIcon,
  SearchIcon,
  SearchLoop,
  SearchMissionIcon,
  SelfieIdentity,
  ShowPassword,
  Signer,
  SortIcon,
  SpinnerIcon,
  Star,
  StarOutline,
  SwitchIcon,
  TableIcon,
  TimeSheetDisabledIcon,
  TimeSheetIcon,
  TrainingIcon,
  TrashIcon,
  TrophyIcon,
  ValidationCercle,
  GamepadIcon,
  IntercomIcon,
  JiraIcon,
  BugIcon,
  Vivier,
  Warning,
  WarningCircle,
  QuestionMarkIcon,
  SaveIcon,
  CogIcon,
  DragIcon,
  PadLockIcon,
  RotateFadingClock,
  SendIcon,
  ReceiptEuroIcon,
  WalletIcon,
  SparklesIcon,
  Forklift,
  HandshakeIcon,
  ReceiptIcon,
  UserSearchIcon,
  PhoneCallIcon,
  MapPinIcon,
  ClipboardListIcon,
  CalendarDaysIcon,
  LayoutDashboardIcon,
  CalendarClockIcon,
  History,
  FlameIcon,
  TargetIcon,
  TrendingUpIcon,
  CircleCheckIcon,
  TrophyLineIcon,
  ChartColumnIcon,
};
